/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import * as moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.TASKS_SERVICE_URL) {
      throw new Error('TASKS_SERVICE_URL must be set in environment');
    }

    return process.env.TASKS_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class TaskInstanceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    getTaskInstancesCount(request: GetTaskInstancesCountRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<TaskInstancesCountResponse[]> {
        let url_ = this.baseUrl + "/api/taskinstance/counts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskInstancesCount(_response);
        });
    }

    protected processGetTaskInstancesCount(response: Response): Promise<TaskInstancesCountResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskInstancesCountResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskInstancesCountResponse[]>(<any>null);
    }

    getTaskInstances(request: GetTaskInstancesRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<TaskInstanceResponse[]> {
        let url_ = this.baseUrl + "/api/taskinstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskInstances(_response);
        });
    }

    protected processGetTaskInstances(response: Response): Promise<TaskInstanceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskInstanceResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskInstanceResponse[]>(<any>null);
    }

    getTaskInstance(residentId: string, taskInstanceId: string, includeEventsAndAdditionalDetails: boolean | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<TaskInstanceResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/taskinstance/{taskInstanceId}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (taskInstanceId === undefined || taskInstanceId === null)
            throw new Error("The parameter 'taskInstanceId' must be defined.");
        url_ = url_.replace("{taskInstanceId}", encodeURIComponent("" + taskInstanceId));
        if (includeEventsAndAdditionalDetails === null)
            throw new Error("The parameter 'includeEventsAndAdditionalDetails' cannot be null.");
        else if (includeEventsAndAdditionalDetails !== undefined)
            url_ += "includeEventsAndAdditionalDetails=" + encodeURIComponent("" + includeEventsAndAdditionalDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskInstance(_response);
        });
    }

    protected processGetTaskInstance(response: Response): Promise<TaskInstanceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskInstanceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskInstanceResponse>(<any>null);
    }

    complete(residentId: string, taskInstanceId: string, request: TaskInstanceCompleteRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/taskinstance/{taskInstanceId}/complete";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (taskInstanceId === undefined || taskInstanceId === null)
            throw new Error("The parameter 'taskInstanceId' must be defined.");
        url_ = url_.replace("{taskInstanceId}", encodeURIComponent("" + taskInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComplete(_response);
        });
    }

    protected processComplete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TaskReportMetricClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    queryDepartmentMetricsForOrganisations(request: TaskReportMetricQueryRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<ReportMetricResponse[]> {
        let url_ = this.baseUrl + "/api/tasks/report/metrics/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryDepartmentMetricsForOrganisations(_response);
        });
    }

    protected processQueryDepartmentMetricsForOrganisations(response: Response): Promise<ReportMetricResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportMetricResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricResponse[]>(<any>null);
    }
}

export class TaskImagesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    getTaskImageUri(residentId: string, assignmentId: string, size: TaskImageSize | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<TaskImageResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/assignments/{assignmentId}/images?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskImageUri(_response);
        });
    }

    protected processGetTaskImageUri(response: Response): Promise<TaskImageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskImageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskImageResponse>(<any>null);
    }

    uploadTaskImage(residentId: string, assignmentId: string, file: FileParameter | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/assignments/{assignmentId}/images";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadTaskImage(_response);
        });
    }

    protected processUploadTaskImage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    deleteTaskImage(residentId: string, assignmentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/assignments/{assignmentId}/images";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTaskImage(_response);
        });
    }

    protected processDeleteTaskImage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class TaskAssignmentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    getTaskAssignment(residentId: string, taskAssignmentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<TaskAssignmentResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/taskAssignments/{taskAssignmentId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (taskAssignmentId === undefined || taskAssignmentId === null)
            throw new Error("The parameter 'taskAssignmentId' must be defined.");
        url_ = url_.replace("{taskAssignmentId}", encodeURIComponent("" + taskAssignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskAssignment(_response);
        });
    }

    protected processGetTaskAssignment(response: Response): Promise<TaskAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskAssignmentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskAssignmentResponse>(<any>null);
    }

    getTaskAssignments(request: GetTaskAssignmentsRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<TaskAssignmentQueryResponse[]> {
        let url_ = this.baseUrl + "/api/taskAssignments/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskAssignments(_response);
        });
    }

    protected processGetTaskAssignments(response: Response): Promise<TaskAssignmentQueryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskAssignmentQueryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskAssignmentQueryResponse[]>(<any>null);
    }

    getTaskAssignmentRepetitionEntriesForPeriod(request: GetTaskAssignmentsForPeriodRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<TaskAssignmentRepetitionEntriesForPeriodResponse> {
        let url_ = this.baseUrl + "/api/taskAssignments/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskAssignmentRepetitionEntriesForPeriod(_response);
        });
    }

    protected processGetTaskAssignmentRepetitionEntriesForPeriod(response: Response): Promise<TaskAssignmentRepetitionEntriesForPeriodResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskAssignmentRepetitionEntriesForPeriodResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskAssignmentRepetitionEntriesForPeriodResponse>(<any>null);
    }

    getTaskAssignmentsNextOccurrence(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<TaskAssignmentNextOccurrenceResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/taskAssignments/nextOccurrence";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskAssignmentsNextOccurrence(_response);
        });
    }

    protected processGetTaskAssignmentsNextOccurrence(response: Response): Promise<TaskAssignmentNextOccurrenceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskAssignmentNextOccurrenceResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskAssignmentNextOccurrenceResponse[]>(<any>null);
    }
}

export class StandardTasksClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    getByCustomerId(customerId: string, includeDeleted: boolean | undefined, trackTraceIds: string[] | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<StandardTaskRestEntity[]> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/standardTasks?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (trackTraceIds !== undefined && trackTraceIds !== null)
            trackTraceIds && trackTraceIds.forEach(item => { url_ += "trackTraceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByCustomerId(_response);
        });
    }

    protected processGetByCustomerId(response: Response): Promise<StandardTaskRestEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskRestEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity[]>(<any>null);
    }

    getByOrganisation(organisationId: string, includeDeleted: boolean | undefined, associatedWithPlanId: string | null | undefined, associatedWithNexusVumSubGoalId: string | null | undefined, onlyAdHoc: boolean | undefined, trackAndTraceIds: string[] | null | undefined, associatedWithId: string | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<StandardTaskRestEntity[]> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardtasks?";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (associatedWithPlanId !== undefined && associatedWithPlanId !== null)
            url_ += "associatedWithPlanId=" + encodeURIComponent("" + associatedWithPlanId) + "&";
        if (associatedWithNexusVumSubGoalId !== undefined && associatedWithNexusVumSubGoalId !== null)
            url_ += "associatedWithNexusVumSubGoalId=" + encodeURIComponent("" + associatedWithNexusVumSubGoalId) + "&";
        if (onlyAdHoc === null)
            throw new Error("The parameter 'onlyAdHoc' cannot be null.");
        else if (onlyAdHoc !== undefined)
            url_ += "onlyAdHoc=" + encodeURIComponent("" + onlyAdHoc) + "&";
        if (trackAndTraceIds !== undefined && trackAndTraceIds !== null)
            trackAndTraceIds && trackAndTraceIds.forEach(item => { url_ += "trackAndTraceIds=" + encodeURIComponent("" + item) + "&"; });
        if (associatedWithId !== undefined && associatedWithId !== null)
            url_ += "associatedWithId=" + encodeURIComponent("" + associatedWithId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByOrganisation(_response);
        });
    }

    protected processGetByOrganisation(response: Response): Promise<StandardTaskRestEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskRestEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity[]>(<any>null);
    }

    createStandardTask(organisationId: string, request: CreateStandardTaskRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<CreateStandardTaskResponse> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardtasks";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateStandardTask(_response);
        });
    }

    protected processCreateStandardTask(response: Response): Promise<CreateStandardTaskResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateStandardTaskResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateStandardTaskResponse>(<any>null);
    }

    getStandardTaskById(standardTaskId: string, trackAndTraceIds: string[] | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<StandardTaskRestEntity> {
        let url_ = this.baseUrl + "/api/standardTasks/{standardTaskId}?";
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        if (trackAndTraceIds !== undefined && trackAndTraceIds !== null)
            trackAndTraceIds && trackAndTraceIds.forEach(item => { url_ += "trackAndTraceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardTaskById(_response);
        });
    }

    protected processGetStandardTaskById(response: Response): Promise<StandardTaskRestEntity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StandardTaskRestEntity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity>(<any>null);
    }

    getStandardTasksByIds(request: GetStandardTasksByIdsRequest, trackAndTraceIds: string[] | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<StandardTaskRestEntity[]> {
        let url_ = this.baseUrl + "/api/standardtasks?";
        if (trackAndTraceIds !== undefined && trackAndTraceIds !== null)
            trackAndTraceIds && trackAndTraceIds.forEach(item => { url_ += "trackAndTraceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardTasksByIds(_response);
        });
    }

    protected processGetStandardTasksByIds(response: Response): Promise<StandardTaskRestEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskRestEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity[]>(<any>null);
    }

    updateStandardTask(organisationId: string, standardTaskId: string, request: UpdateStandardTaskRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<MinimalPackageInfo> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/{standardTaskId}";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStandardTask(_response);
        });
    }

    protected processUpdateStandardTask(response: Response): Promise<MinimalPackageInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimalPackageInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MinimalPackageInfo>(<any>null);
    }

    deleteStandardTask(organisationId: string, standardTaskId: string, request: DeleteStandardTaskRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<MinimalPackageInfo> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/{standardTaskId}";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteStandardTask(_response);
        });
    }

    protected processDeleteStandardTask(response: Response): Promise<MinimalPackageInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimalPackageInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MinimalPackageInfo>(<any>null);
    }

    getStandardTasksAssociatedWithIdsBatch(organisationId: string, request: GetStandardTasksAssociatedWithIdsBatchRequest, trackAndTraceIds: string[] | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<StandardTaskRestEntity[]> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/associatedWithIds?";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (trackAndTraceIds !== undefined && trackAndTraceIds !== null)
            trackAndTraceIds && trackAndTraceIds.forEach(item => { url_ += "trackAndTraceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardTasksAssociatedWithIdsBatch(_response);
        });
    }

    protected processGetStandardTasksAssociatedWithIdsBatch(response: Response): Promise<StandardTaskRestEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskRestEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity[]>(<any>null);
    }
}

export class StandardTasksHistoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    getStandardTasksHistory(request: QueryStandardTasksHistoryRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<StandardTasksHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/standardtasks/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardTasksHistory(_response);
        });
    }

    protected processGetStandardTasksHistory(response: Response): Promise<StandardTasksHistoryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTasksHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTasksHistoryResponse[]>(<any>null);
    }
}

export class AssociationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    updateNexusVumSubGoalAssociations(concatenatedSubGoalId: string, associationsRequest: UpdateNexusVumSubGoalAssociationsRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<NexusVumSubGoalAssociationsUpdatedResponse> {
        let url_ = this.baseUrl + "/api/standardTasks/associations/nexusVumSubGoals/{concatenatedSubGoalId}";
        if (concatenatedSubGoalId === undefined || concatenatedSubGoalId === null)
            throw new Error("The parameter 'concatenatedSubGoalId' must be defined.");
        url_ = url_.replace("{concatenatedSubGoalId}", encodeURIComponent("" + concatenatedSubGoalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(associationsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNexusVumSubGoalAssociations(_response);
        });
    }

    protected processUpdateNexusVumSubGoalAssociations(response: Response): Promise<NexusVumSubGoalAssociationsUpdatedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NexusVumSubGoalAssociationsUpdatedResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NexusVumSubGoalAssociationsUpdatedResponse>(<any>null);
    }

    updatePlanAssociations(organisationId: string, planId: string, request: UpdatePlanAssociationsRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<CreateAndDeleteAssociationBatchResponse> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/associations/plans/{planId}";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePlanAssociations(_response);
        });
    }

    protected processUpdatePlanAssociations(response: Response): Promise<CreateAndDeleteAssociationBatchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAndDeleteAssociationBatchResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAndDeleteAssociationBatchResponse>(<any>null);
    }

    getStandardTasksAssociatedWithPlansBatch(organisationId: string, request: GetStandardTasksAssociatedWithPlanIdsBatchRequest, trackAndTraceIds: string[] | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<StandardTaskRestEntity[]> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/associations/plans?";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (trackAndTraceIds !== undefined && trackAndTraceIds !== null)
            trackAndTraceIds && trackAndTraceIds.forEach(item => { url_ += "trackAndTraceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardTasksAssociatedWithPlansBatch(_response);
        });
    }

    protected processGetStandardTasksAssociatedWithPlansBatch(response: Response): Promise<StandardTaskRestEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskRestEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity[]>(<any>null);
    }

    getStandardTasksAssociatedWithNexusVumSubGoalsBatch(organisationId: string, request: GetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest, trackAndTraceIds: string[] | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<StandardTaskRestEntity[]> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/standardTasks/associations/nexusVumSubGoals?";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (trackAndTraceIds !== undefined && trackAndTraceIds !== null)
            trackAndTraceIds && trackAndTraceIds.forEach(item => { url_ += "trackAndTraceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardTasksAssociatedWithNexusVumSubGoalsBatch(_response);
        });
    }

    protected processGetStandardTasksAssociatedWithNexusVumSubGoalsBatch(response: Response): Promise<StandardTaskRestEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskRestEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskRestEntity[]>(<any>null);
    }

    updateAssociatedForms(standardTaskId: string, request: UpdateAssociatedFormsRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/standardTasks/{standardTaskId}/associations/forms";
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAssociatedForms(_response);
        });
    }

    protected processUpdateAssociatedForms(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAssociatedForms(standardTaskId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<StandardTaskAssociatedFormResponse[]> {
        let url_ = this.baseUrl + "/api/standardTasks/{standardTaskId}/associations/forms";
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssociatedForms(_response);
        });
    }

    protected processGetAssociatedForms(response: Response): Promise<StandardTaskAssociatedFormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskAssociatedFormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskAssociatedFormResponse[]>(<any>null);
    }

    getFormsAssociatedWithTaskInstance(standardTaskId: string, taskInstanceId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<StandardTaskAssociatedFormResponse[]> {
        let url_ = this.baseUrl + "/api/standardTasks/{standardTaskId}/associations/forms/taskInstance/{taskInstanceId}";
        if (standardTaskId === undefined || standardTaskId === null)
            throw new Error("The parameter 'standardTaskId' must be defined.");
        url_ = url_.replace("{standardTaskId}", encodeURIComponent("" + standardTaskId));
        if (taskInstanceId === undefined || taskInstanceId === null)
            throw new Error("The parameter 'taskInstanceId' must be defined.");
        url_ = url_.replace("{taskInstanceId}", encodeURIComponent("" + taskInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsAssociatedWithTaskInstance(_response);
        });
    }

    protected processGetFormsAssociatedWithTaskInstance(response: Response): Promise<StandardTaskAssociatedFormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardTaskAssociatedFormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardTaskAssociatedFormResponse[]>(<any>null);
    }
}

export class AssignmentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-tasks-dev.sekoia.one", baseUrl);
    }

    getAssignmentAudits(residentId: string, assignmentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<AuditResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/audits";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignmentAudits(_response);
        });
    }

    protected processGetAssignmentAudits(response: Response): Promise<AuditResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditResponse[]>(<any>null);
    }

    addAssignmentInstructions(residentId: string, assignmentId: string, request: AddAssignmentInstructionsRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<CreatedAssignmentInstructionsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/instructions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAssignmentInstructions(_response);
        });
    }

    protected processAddAssignmentInstructions(response: Response): Promise<CreatedAssignmentInstructionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedAssignmentInstructionsResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatedAssignmentInstructionsResponse>(<any>null);
    }

    getAssignmentInstructions(residentId: string, assignmentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<AssignmentInstructionResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/instructions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignmentInstructions(_response);
        });
    }

    protected processGetAssignmentInstructions(response: Response): Promise<AssignmentInstructionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignmentInstructionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentInstructionResponse[]>(<any>null);
    }

    getAssignmentPrescription(residentId: string, assignmentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<AssignmentPrescriptionResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/prescription";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignmentPrescription(_response);
        });
    }

    protected processGetAssignmentPrescription(response: Response): Promise<AssignmentPrescriptionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignmentPrescriptionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentPrescriptionResponse>(<any>null);
    }

    updateAssignmentPrescription(residentId: string, assignmentId: string, request: UpdateAssignmentPrescriptionRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/prescription";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAssignmentPrescription(_response);
        });
    }

    protected processUpdateAssignmentPrescription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    addAssignmentForms(residentId: string, assignmentId: string, request: AddAssignmentFormsRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/forms";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAssignmentForms(_response);
        });
    }

    protected processAddAssignmentForms(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAssignmentForms(residentId: string, assignmentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<AssignmentFormResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/forms";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignmentForms(_response);
        });
    }

    protected processGetAssignmentForms(response: Response): Promise<AssignmentFormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignmentFormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentFormResponse[]>(<any>null);
    }

    deleteAssignmentFormForResident(residentId: string, formId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/forms/{formId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAssignmentFormForResident(_response);
        });
    }

    protected processDeleteAssignmentFormForResident(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    deleteAllAssignmentFormsByFormId(formId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/assignments/forms/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAllAssignmentFormsByFormId(_response);
        });
    }

    protected processDeleteAllAssignmentFormsByFormId(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getTaskInstanceAssignments(residentId: string, assignmentId: string, instanceId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<TaskInstanceAssignmentsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/assignments/{assignmentId}/taskInstance/{instanceId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskInstanceAssignments(_response);
        });
    }

    protected processGetTaskInstanceAssignments(response: Response): Promise<TaskInstanceAssignmentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskInstanceAssignmentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskInstanceAssignmentsResponse>(<any>null);
    }
}

export class TaskInstancesCountResponse implements ITaskInstancesCountResponse {
    residentId!: string;
    cancelled!: number;
    completed!: number;
    moved!: number;
    ready!: number;

    constructor(data?: ITaskInstancesCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"];
            this.cancelled = _data["cancelled"];
            this.completed = _data["completed"];
            this.moved = _data["moved"];
            this.ready = _data["ready"];
        }
    }

    static fromJS(data: any): TaskInstancesCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInstancesCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId;
        data["cancelled"] = this.cancelled;
        data["completed"] = this.completed;
        data["moved"] = this.moved;
        data["ready"] = this.ready;
        return data; 
    }
}

export interface ITaskInstancesCountResponse {
    residentId: string;
    cancelled: number;
    completed: number;
    moved: number;
    ready: number;
}

export class GetTaskInstancesCountRequest implements IGetTaskInstancesCountRequest {
    residentIds!: string[];
    from!: moment.Moment;
    to!: moment.Moment;

    constructor(data?: IGetTaskInstancesCountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskInstancesCountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskInstancesCountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["from"] = this.from ? this.from.format('YYYY-MM-DD') : <any>undefined;
        data["to"] = this.to ? this.to.format('YYYY-MM-DD') : <any>undefined;
        return data; 
    }
}

export interface IGetTaskInstancesCountRequest {
    residentIds: string[];
    from: moment.Moment;
    to: moment.Moment;
}

export class TaskInstanceResponse implements ITaskInstanceResponse {
    id!: string;
    customerId!: string;
    standardTaskId!: string;
    taskEntryId!: string;
    intervalStartTime!: moment.Moment;
    intervalEndTime!: moment.Moment;
    title!: string;
    residentId!: string;
    taskOrganisationId!: string;
    taskState!: TaskState;
    isResidentTask!: boolean;
    isMedicationRelated!: boolean;
    isContactRelated!: boolean;
    isTwoPersonTask!: boolean;
    isHealthAct!: boolean;
    isCreatedAdHoc!: boolean;
    eventTimestamp?: moment.Moment | undefined;
    eventEmployeeId?: string | undefined;
    professionId!: string;
    delegatedProfessionId?: string | undefined;
    taskCompletionOffsetInMinutes?: number | undefined;
    expectedDurationInMinutes!: number;
    description?: string | undefined;
    assignedAtTimestamp?: moment.Moment | undefined;
    assignedByEmployeeId?: string | undefined;
    assignedByEmployeeProfessionId?: number | undefined;
    lastUpdatedAtTimestamp?: moment.Moment | undefined;
    standardTaskInformation?: TaskInstanceStandardTaskInformationResponse | undefined;
    events!: TaskEventResponse[];
    moved!: boolean;
    movedHere!: boolean;
    originalTaskAssignmentId?: string | undefined;

    constructor(data?: ITaskInstanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.events = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.standardTaskId = _data["standardTaskId"];
            this.taskEntryId = _data["taskEntryId"];
            this.intervalStartTime = _data["intervalStartTime"] ? moment(_data["intervalStartTime"].toString()) : <any>undefined;
            this.intervalEndTime = _data["intervalEndTime"] ? moment(_data["intervalEndTime"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.residentId = _data["residentId"];
            this.taskOrganisationId = _data["taskOrganisationId"];
            this.taskState = _data["taskState"];
            this.isResidentTask = _data["isResidentTask"];
            this.isMedicationRelated = _data["isMedicationRelated"];
            this.isContactRelated = _data["isContactRelated"];
            this.isTwoPersonTask = _data["isTwoPersonTask"];
            this.isHealthAct = _data["isHealthAct"];
            this.isCreatedAdHoc = _data["isCreatedAdHoc"];
            this.eventTimestamp = _data["eventTimestamp"] ? moment(_data["eventTimestamp"].toString()) : <any>undefined;
            this.eventEmployeeId = _data["eventEmployeeId"];
            this.professionId = _data["professionId"];
            this.delegatedProfessionId = _data["delegatedProfessionId"];
            this.taskCompletionOffsetInMinutes = _data["taskCompletionOffsetInMinutes"];
            this.expectedDurationInMinutes = _data["expectedDurationInMinutes"];
            this.description = _data["description"];
            this.assignedAtTimestamp = _data["assignedAtTimestamp"] ? moment(_data["assignedAtTimestamp"].toString()) : <any>undefined;
            this.assignedByEmployeeId = _data["assignedByEmployeeId"];
            this.assignedByEmployeeProfessionId = _data["assignedByEmployeeProfessionId"];
            this.lastUpdatedAtTimestamp = _data["lastUpdatedAtTimestamp"] ? moment(_data["lastUpdatedAtTimestamp"].toString()) : <any>undefined;
            this.standardTaskInformation = _data["standardTaskInformation"] ? TaskInstanceStandardTaskInformationResponse.fromJS(_data["standardTaskInformation"]) : <any>undefined;
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(TaskEventResponse.fromJS(item));
            }
            this.moved = _data["moved"];
            this.movedHere = _data["movedHere"];
            this.originalTaskAssignmentId = _data["originalTaskAssignmentId"];
        }
    }

    static fromJS(data: any): TaskInstanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInstanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["standardTaskId"] = this.standardTaskId;
        data["taskEntryId"] = this.taskEntryId;
        data["intervalStartTime"] = this.intervalStartTime ? this.intervalStartTime.toISOString() : <any>undefined;
        data["intervalEndTime"] = this.intervalEndTime ? this.intervalEndTime.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["residentId"] = this.residentId;
        data["taskOrganisationId"] = this.taskOrganisationId;
        data["taskState"] = this.taskState;
        data["isResidentTask"] = this.isResidentTask;
        data["isMedicationRelated"] = this.isMedicationRelated;
        data["isContactRelated"] = this.isContactRelated;
        data["isTwoPersonTask"] = this.isTwoPersonTask;
        data["isHealthAct"] = this.isHealthAct;
        data["isCreatedAdHoc"] = this.isCreatedAdHoc;
        data["eventTimestamp"] = this.eventTimestamp ? this.eventTimestamp.toISOString() : <any>undefined;
        data["eventEmployeeId"] = this.eventEmployeeId;
        data["professionId"] = this.professionId;
        data["delegatedProfessionId"] = this.delegatedProfessionId;
        data["taskCompletionOffsetInMinutes"] = this.taskCompletionOffsetInMinutes;
        data["expectedDurationInMinutes"] = this.expectedDurationInMinutes;
        data["description"] = this.description;
        data["assignedAtTimestamp"] = this.assignedAtTimestamp ? this.assignedAtTimestamp.toISOString() : <any>undefined;
        data["assignedByEmployeeId"] = this.assignedByEmployeeId;
        data["assignedByEmployeeProfessionId"] = this.assignedByEmployeeProfessionId;
        data["lastUpdatedAtTimestamp"] = this.lastUpdatedAtTimestamp ? this.lastUpdatedAtTimestamp.toISOString() : <any>undefined;
        data["standardTaskInformation"] = this.standardTaskInformation ? this.standardTaskInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        data["moved"] = this.moved;
        data["movedHere"] = this.movedHere;
        data["originalTaskAssignmentId"] = this.originalTaskAssignmentId;
        return data; 
    }
}

export interface ITaskInstanceResponse {
    id: string;
    customerId: string;
    standardTaskId: string;
    taskEntryId: string;
    intervalStartTime: moment.Moment;
    intervalEndTime: moment.Moment;
    title: string;
    residentId: string;
    taskOrganisationId: string;
    taskState: TaskState;
    isResidentTask: boolean;
    isMedicationRelated: boolean;
    isContactRelated: boolean;
    isTwoPersonTask: boolean;
    isHealthAct: boolean;
    isCreatedAdHoc: boolean;
    eventTimestamp?: moment.Moment | undefined;
    eventEmployeeId?: string | undefined;
    professionId: string;
    delegatedProfessionId?: string | undefined;
    taskCompletionOffsetInMinutes?: number | undefined;
    expectedDurationInMinutes: number;
    description?: string | undefined;
    assignedAtTimestamp?: moment.Moment | undefined;
    assignedByEmployeeId?: string | undefined;
    assignedByEmployeeProfessionId?: number | undefined;
    lastUpdatedAtTimestamp?: moment.Moment | undefined;
    standardTaskInformation?: TaskInstanceStandardTaskInformationResponse | undefined;
    events: TaskEventResponse[];
    moved: boolean;
    movedHere: boolean;
    originalTaskAssignmentId?: string | undefined;
}

export enum TaskState {
    Ready = "Ready",
    Completed = "Completed",
    Moved = "Moved",
    Cancelled = "Cancelled",
}

export class TaskInstanceStandardTaskInformationResponse implements ITaskInstanceStandardTaskInformationResponse {
    associatedNexusVumSubGoalIds!: string[];
    associatedPlanIds!: string[];
    categoryIds!: string[];
    delegationTagIds!: string[];
    accessControlTagIds!: string[];
    canCancel!: boolean;
    canMove!: boolean;

    constructor(data?: ITaskInstanceStandardTaskInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associatedNexusVumSubGoalIds = [];
            this.associatedPlanIds = [];
            this.categoryIds = [];
            this.delegationTagIds = [];
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associatedNexusVumSubGoalIds"])) {
                this.associatedNexusVumSubGoalIds = [] as any;
                for (let item of _data["associatedNexusVumSubGoalIds"])
                    this.associatedNexusVumSubGoalIds!.push(item);
            }
            if (Array.isArray(_data["associatedPlanIds"])) {
                this.associatedPlanIds = [] as any;
                for (let item of _data["associatedPlanIds"])
                    this.associatedPlanIds!.push(item);
            }
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            if (Array.isArray(_data["delegationTagIds"])) {
                this.delegationTagIds = [] as any;
                for (let item of _data["delegationTagIds"])
                    this.delegationTagIds!.push(item);
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            this.canCancel = _data["canCancel"];
            this.canMove = _data["canMove"];
        }
    }

    static fromJS(data: any): TaskInstanceStandardTaskInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInstanceStandardTaskInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associatedNexusVumSubGoalIds)) {
            data["associatedNexusVumSubGoalIds"] = [];
            for (let item of this.associatedNexusVumSubGoalIds)
                data["associatedNexusVumSubGoalIds"].push(item);
        }
        if (Array.isArray(this.associatedPlanIds)) {
            data["associatedPlanIds"] = [];
            for (let item of this.associatedPlanIds)
                data["associatedPlanIds"].push(item);
        }
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.delegationTagIds)) {
            data["delegationTagIds"] = [];
            for (let item of this.delegationTagIds)
                data["delegationTagIds"].push(item);
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["canCancel"] = this.canCancel;
        data["canMove"] = this.canMove;
        return data; 
    }
}

export interface ITaskInstanceStandardTaskInformationResponse {
    associatedNexusVumSubGoalIds: string[];
    associatedPlanIds: string[];
    categoryIds: string[];
    delegationTagIds: string[];
    accessControlTagIds: string[];
    canCancel: boolean;
    canMove: boolean;
}

export class TaskEventResponse implements ITaskEventResponse {
    employeeId!: string;
    employeeProfessionId!: number;
    timestamp!: moment.Moment;
    kind!: TaskEventType;
    assistantId?: string | undefined;
    assistantGlobalId?: string | undefined;
    assistantProfessionId?: number | undefined;
    movedFrom?: moment.Moment | undefined;
    movedTo?: moment.Moment | undefined;
    reason?: string | undefined;

    constructor(data?: ITaskEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeProfessionId = _data["employeeProfessionId"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.kind = _data["kind"];
            this.assistantId = _data["assistantId"];
            this.assistantGlobalId = _data["assistantGlobalId"];
            this.assistantProfessionId = _data["assistantProfessionId"];
            this.movedFrom = _data["movedFrom"] ? moment(_data["movedFrom"].toString()) : <any>undefined;
            this.movedTo = _data["movedTo"] ? moment(_data["movedTo"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): TaskEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeProfessionId"] = this.employeeProfessionId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["kind"] = this.kind;
        data["assistantId"] = this.assistantId;
        data["assistantGlobalId"] = this.assistantGlobalId;
        data["assistantProfessionId"] = this.assistantProfessionId;
        data["movedFrom"] = this.movedFrom ? this.movedFrom.format('YYYY-MM-DD') : <any>undefined;
        data["movedTo"] = this.movedTo ? this.movedTo.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        return data; 
    }
}

export interface ITaskEventResponse {
    employeeId: string;
    employeeProfessionId: number;
    timestamp: moment.Moment;
    kind: TaskEventType;
    assistantId?: string | undefined;
    assistantGlobalId?: string | undefined;
    assistantProfessionId?: number | undefined;
    movedFrom?: moment.Moment | undefined;
    movedTo?: moment.Moment | undefined;
    reason?: string | undefined;
}

export enum TaskEventType {
    Unknown = "Unknown",
    Completed = "Completed",
    Cancelled = "Cancelled",
    MovedAway = "MovedAway",
    MovedHere = "MovedHere",
    CompletionUndone = "CompletionUndone",
    CancellationUndone = "CancellationUndone",
}

export class GetTaskInstancesRequest implements IGetTaskInstancesRequest {
    from!: moment.Moment;
    to!: moment.Moment;
    locationIds!: string[];
    residentIds!: string[];
    includeEventsAndAdditionalDetails!: boolean;

    constructor(data?: IGetTaskInstancesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.locationIds = [];
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            this.includeEventsAndAdditionalDetails = _data["includeEventsAndAdditionalDetails"];
        }
    }

    static fromJS(data: any): GetTaskInstancesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskInstancesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.format('YYYY-MM-DD') : <any>undefined;
        data["to"] = this.to ? this.to.format('YYYY-MM-DD') : <any>undefined;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["includeEventsAndAdditionalDetails"] = this.includeEventsAndAdditionalDetails;
        return data; 
    }
}

export interface IGetTaskInstancesRequest {
    from: moment.Moment;
    to: moment.Moment;
    locationIds: string[];
    residentIds: string[];
    includeEventsAndAdditionalDetails: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export class TaskInstanceCompleteRequest implements ITaskInstanceCompleteRequest {
    reason?: string | undefined;
    assistantId?: string | undefined;

    constructor(data?: ITaskInstanceCompleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.assistantId = _data["assistantId"];
        }
    }

    static fromJS(data: any): TaskInstanceCompleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInstanceCompleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["assistantId"] = this.assistantId;
        return data; 
    }
}

export interface ITaskInstanceCompleteRequest {
    reason?: string | undefined;
    assistantId?: string | undefined;
}

export class ReportMetricResponse implements IReportMetricResponse {

    protected _discriminator: string;

    constructor(data?: IReportMetricResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ReportMetricResponse";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ReportMetricResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "TaskStatusReportMetricResponse") {
            let result = new TaskStatusReportMetricResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TaskCompletionReportMetricResponse") {
            let result = new TaskCompletionReportMetricResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TaskProfessionsReportMetricResponse") {
            let result = new TaskProfessionsReportMetricResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TaskDepartmentLoadReportMetricResponse") {
            let result = new TaskDepartmentLoadReportMetricResponse();
            result.init(data);
            return result;
        }
        let result = new ReportMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator; 
        return data; 
    }
}

export interface IReportMetricResponse {
}

export class TaskStatusReportMetricResponse extends ReportMetricResponse implements ITaskStatusReportMetricResponse {
    taskStatusMetricsForOrganisations!: TaskStatusForOrganisationResponse[];

    constructor(data?: ITaskStatusReportMetricResponse) {
        super(data);
        if (!data) {
            this.taskStatusMetricsForOrganisations = [];
        }
        this._discriminator = "TaskStatusReportMetricResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["taskStatusMetricsForOrganisations"])) {
                this.taskStatusMetricsForOrganisations = [] as any;
                for (let item of _data["taskStatusMetricsForOrganisations"])
                    this.taskStatusMetricsForOrganisations!.push(TaskStatusForOrganisationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskStatusReportMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStatusReportMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskStatusMetricsForOrganisations)) {
            data["taskStatusMetricsForOrganisations"] = [];
            for (let item of this.taskStatusMetricsForOrganisations)
                data["taskStatusMetricsForOrganisations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskStatusReportMetricResponse extends IReportMetricResponse {
    taskStatusMetricsForOrganisations: TaskStatusForOrganisationResponse[];
}

export class TaskStatusForOrganisationResponse implements ITaskStatusForOrganisationResponse {
    organisationId!: string;
    date!: moment.Moment;
    taskStatusMetricsForDepartments!: TasksStatusForDepartmentResponse[];

    constructor(data?: ITaskStatusForOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskStatusMetricsForDepartments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["taskStatusMetricsForDepartments"])) {
                this.taskStatusMetricsForDepartments = [] as any;
                for (let item of _data["taskStatusMetricsForDepartments"])
                    this.taskStatusMetricsForDepartments!.push(TasksStatusForDepartmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskStatusForOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStatusForOrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : <any>undefined;
        if (Array.isArray(this.taskStatusMetricsForDepartments)) {
            data["taskStatusMetricsForDepartments"] = [];
            for (let item of this.taskStatusMetricsForDepartments)
                data["taskStatusMetricsForDepartments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskStatusForOrganisationResponse {
    organisationId: string;
    date: moment.Moment;
    taskStatusMetricsForDepartments: TasksStatusForDepartmentResponse[];
}

export class TasksStatusForDepartmentResponse implements ITasksStatusForDepartmentResponse {
    departmentId!: string;
    completed!: number;
    cancelled!: number;
    moved!: number;
    unhandled!: number;

    constructor(data?: ITasksStatusForDepartmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"];
            this.completed = _data["completed"];
            this.cancelled = _data["cancelled"];
            this.moved = _data["moved"];
            this.unhandled = _data["unhandled"];
        }
    }

    static fromJS(data: any): TasksStatusForDepartmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TasksStatusForDepartmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId;
        data["completed"] = this.completed;
        data["cancelled"] = this.cancelled;
        data["moved"] = this.moved;
        data["unhandled"] = this.unhandled;
        return data; 
    }
}

export interface ITasksStatusForDepartmentResponse {
    departmentId: string;
    completed: number;
    cancelled: number;
    moved: number;
    unhandled: number;
}

export class TaskCompletionReportMetricResponse extends ReportMetricResponse implements ITaskCompletionReportMetricResponse {
    taskCompletionMetricsForOrganisations!: TaskCompletionForOrganisationResponse[];

    constructor(data?: ITaskCompletionReportMetricResponse) {
        super(data);
        if (!data) {
            this.taskCompletionMetricsForOrganisations = [];
        }
        this._discriminator = "TaskCompletionReportMetricResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["taskCompletionMetricsForOrganisations"])) {
                this.taskCompletionMetricsForOrganisations = [] as any;
                for (let item of _data["taskCompletionMetricsForOrganisations"])
                    this.taskCompletionMetricsForOrganisations!.push(TaskCompletionForOrganisationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskCompletionReportMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCompletionReportMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskCompletionMetricsForOrganisations)) {
            data["taskCompletionMetricsForOrganisations"] = [];
            for (let item of this.taskCompletionMetricsForOrganisations)
                data["taskCompletionMetricsForOrganisations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskCompletionReportMetricResponse extends IReportMetricResponse {
    taskCompletionMetricsForOrganisations: TaskCompletionForOrganisationResponse[];
}

export class TaskCompletionForOrganisationResponse implements ITaskCompletionForOrganisationResponse {
    organisationId!: string;
    taskCompletionMetricsForDepartments!: TaskCompletionForDepartmentResponse[];

    constructor(data?: ITaskCompletionForOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskCompletionMetricsForDepartments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            if (Array.isArray(_data["taskCompletionMetricsForDepartments"])) {
                this.taskCompletionMetricsForDepartments = [] as any;
                for (let item of _data["taskCompletionMetricsForDepartments"])
                    this.taskCompletionMetricsForDepartments!.push(TaskCompletionForDepartmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskCompletionForOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCompletionForOrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        if (Array.isArray(this.taskCompletionMetricsForDepartments)) {
            data["taskCompletionMetricsForDepartments"] = [];
            for (let item of this.taskCompletionMetricsForDepartments)
                data["taskCompletionMetricsForDepartments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskCompletionForOrganisationResponse {
    organisationId: string;
    taskCompletionMetricsForDepartments: TaskCompletionForDepartmentResponse[];
}

export class TaskCompletionForDepartmentResponse implements ITaskCompletionForDepartmentResponse {
    departmentId!: string;
    taskCompletionMetricsOffsetCounts!: TaskCompletionMetricResponse[];

    constructor(data?: ITaskCompletionForDepartmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskCompletionMetricsOffsetCounts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"];
            if (Array.isArray(_data["taskCompletionMetricsOffsetCounts"])) {
                this.taskCompletionMetricsOffsetCounts = [] as any;
                for (let item of _data["taskCompletionMetricsOffsetCounts"])
                    this.taskCompletionMetricsOffsetCounts!.push(TaskCompletionMetricResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskCompletionForDepartmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCompletionForDepartmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId;
        if (Array.isArray(this.taskCompletionMetricsOffsetCounts)) {
            data["taskCompletionMetricsOffsetCounts"] = [];
            for (let item of this.taskCompletionMetricsOffsetCounts)
                data["taskCompletionMetricsOffsetCounts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskCompletionForDepartmentResponse {
    departmentId: string;
    taskCompletionMetricsOffsetCounts: TaskCompletionMetricResponse[];
}

export class TaskCompletionMetricResponse implements ITaskCompletionMetricResponse {
    taskCompletionOffsetInMinutes!: number;
    count!: number;

    constructor(data?: ITaskCompletionMetricResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskCompletionOffsetInMinutes = _data["taskCompletionOffsetInMinutes"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): TaskCompletionMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCompletionMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskCompletionOffsetInMinutes"] = this.taskCompletionOffsetInMinutes;
        data["count"] = this.count;
        return data; 
    }
}

export interface ITaskCompletionMetricResponse {
    taskCompletionOffsetInMinutes: number;
    count: number;
}

export class TaskProfessionsReportMetricResponse extends ReportMetricResponse implements ITaskProfessionsReportMetricResponse {
    taskProfessionsMetricForOrganisations!: TaskProfessionsMetricForOrganisationResponse[];

    constructor(data?: ITaskProfessionsReportMetricResponse) {
        super(data);
        if (!data) {
            this.taskProfessionsMetricForOrganisations = [];
        }
        this._discriminator = "TaskProfessionsReportMetricResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["taskProfessionsMetricForOrganisations"])) {
                this.taskProfessionsMetricForOrganisations = [] as any;
                for (let item of _data["taskProfessionsMetricForOrganisations"])
                    this.taskProfessionsMetricForOrganisations!.push(TaskProfessionsMetricForOrganisationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskProfessionsReportMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProfessionsReportMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskProfessionsMetricForOrganisations)) {
            data["taskProfessionsMetricForOrganisations"] = [];
            for (let item of this.taskProfessionsMetricForOrganisations)
                data["taskProfessionsMetricForOrganisations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskProfessionsReportMetricResponse extends IReportMetricResponse {
    taskProfessionsMetricForOrganisations: TaskProfessionsMetricForOrganisationResponse[];
}

export class TaskProfessionsMetricForOrganisationResponse implements ITaskProfessionsMetricForOrganisationResponse {
    organisationId!: string;
    taskProfessionsMetricsForDepartments!: TaskProfessionsMetricForDepartmentResponse[];

    constructor(data?: ITaskProfessionsMetricForOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskProfessionsMetricsForDepartments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            if (Array.isArray(_data["taskProfessionsMetricsForDepartments"])) {
                this.taskProfessionsMetricsForDepartments = [] as any;
                for (let item of _data["taskProfessionsMetricsForDepartments"])
                    this.taskProfessionsMetricsForDepartments!.push(TaskProfessionsMetricForDepartmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskProfessionsMetricForOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProfessionsMetricForOrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        if (Array.isArray(this.taskProfessionsMetricsForDepartments)) {
            data["taskProfessionsMetricsForDepartments"] = [];
            for (let item of this.taskProfessionsMetricsForDepartments)
                data["taskProfessionsMetricsForDepartments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskProfessionsMetricForOrganisationResponse {
    organisationId: string;
    taskProfessionsMetricsForDepartments: TaskProfessionsMetricForDepartmentResponse[];
}

export class TaskProfessionsMetricForDepartmentResponse implements ITaskProfessionsMetricForDepartmentResponse {
    taskProfessionMetrics!: TaskProfessionMetricResponse[];
    departmentId!: string;

    constructor(data?: ITaskProfessionsMetricForDepartmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskProfessionMetrics = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taskProfessionMetrics"])) {
                this.taskProfessionMetrics = [] as any;
                for (let item of _data["taskProfessionMetrics"])
                    this.taskProfessionMetrics!.push(TaskProfessionMetricResponse.fromJS(item));
            }
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): TaskProfessionsMetricForDepartmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProfessionsMetricForDepartmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskProfessionMetrics)) {
            data["taskProfessionMetrics"] = [];
            for (let item of this.taskProfessionMetrics)
                data["taskProfessionMetrics"].push(item.toJSON());
        }
        data["departmentId"] = this.departmentId;
        return data; 
    }
}

export interface ITaskProfessionsMetricForDepartmentResponse {
    taskProfessionMetrics: TaskProfessionMetricResponse[];
    departmentId: string;
}

export class TaskProfessionMetricResponse implements ITaskProfessionMetricResponse {
    professionId!: string;
    combinedExpectedDurationInMinutes!: number;
    amountOfTasks!: number;

    constructor(data?: ITaskProfessionMetricResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.combinedExpectedDurationInMinutes = _data["combinedExpectedDurationInMinutes"];
            this.amountOfTasks = _data["amountOfTasks"];
        }
    }

    static fromJS(data: any): TaskProfessionMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskProfessionMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["combinedExpectedDurationInMinutes"] = this.combinedExpectedDurationInMinutes;
        data["amountOfTasks"] = this.amountOfTasks;
        return data; 
    }
}

export interface ITaskProfessionMetricResponse {
    professionId: string;
    combinedExpectedDurationInMinutes: number;
    amountOfTasks: number;
}

export class TaskDepartmentLoadReportMetricResponse extends ReportMetricResponse implements ITaskDepartmentLoadReportMetricResponse {
    taskDepartmentLoadReportMetricForOrganisations!: TaskDepartmentLoadForOrganisationResponse[];

    constructor(data?: ITaskDepartmentLoadReportMetricResponse) {
        super(data);
        if (!data) {
            this.taskDepartmentLoadReportMetricForOrganisations = [];
        }
        this._discriminator = "TaskDepartmentLoadReportMetricResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["taskDepartmentLoadReportMetricForOrganisations"])) {
                this.taskDepartmentLoadReportMetricForOrganisations = [] as any;
                for (let item of _data["taskDepartmentLoadReportMetricForOrganisations"])
                    this.taskDepartmentLoadReportMetricForOrganisations!.push(TaskDepartmentLoadForOrganisationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskDepartmentLoadReportMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDepartmentLoadReportMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskDepartmentLoadReportMetricForOrganisations)) {
            data["taskDepartmentLoadReportMetricForOrganisations"] = [];
            for (let item of this.taskDepartmentLoadReportMetricForOrganisations)
                data["taskDepartmentLoadReportMetricForOrganisations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskDepartmentLoadReportMetricResponse extends IReportMetricResponse {
    taskDepartmentLoadReportMetricForOrganisations: TaskDepartmentLoadForOrganisationResponse[];
}

export class TaskDepartmentLoadForOrganisationResponse implements ITaskDepartmentLoadForOrganisationResponse {
    organisationId!: string;
    taskProfessionsMetricsForDepartments!: TaskDepartmentLoadForDepartmentResponse[];

    constructor(data?: ITaskDepartmentLoadForOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskProfessionsMetricsForDepartments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            if (Array.isArray(_data["taskProfessionsMetricsForDepartments"])) {
                this.taskProfessionsMetricsForDepartments = [] as any;
                for (let item of _data["taskProfessionsMetricsForDepartments"])
                    this.taskProfessionsMetricsForDepartments!.push(TaskDepartmentLoadForDepartmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskDepartmentLoadForOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDepartmentLoadForOrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        if (Array.isArray(this.taskProfessionsMetricsForDepartments)) {
            data["taskProfessionsMetricsForDepartments"] = [];
            for (let item of this.taskProfessionsMetricsForDepartments)
                data["taskProfessionsMetricsForDepartments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskDepartmentLoadForOrganisationResponse {
    organisationId: string;
    taskProfessionsMetricsForDepartments: TaskDepartmentLoadForDepartmentResponse[];
}

export class TaskDepartmentLoadForDepartmentResponse implements ITaskDepartmentLoadForDepartmentResponse {
    taskDepartmentLoadMetric!: TaskDepartmentLoadMetricResponse;
    departmentId!: string;

    constructor(data?: ITaskDepartmentLoadForDepartmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskDepartmentLoadMetric = new TaskDepartmentLoadMetricResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskDepartmentLoadMetric = _data["taskDepartmentLoadMetric"] ? TaskDepartmentLoadMetricResponse.fromJS(_data["taskDepartmentLoadMetric"]) : new TaskDepartmentLoadMetricResponse();
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): TaskDepartmentLoadForDepartmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDepartmentLoadForDepartmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskDepartmentLoadMetric"] = this.taskDepartmentLoadMetric ? this.taskDepartmentLoadMetric.toJSON() : <any>undefined;
        data["departmentId"] = this.departmentId;
        return data; 
    }
}

export interface ITaskDepartmentLoadForDepartmentResponse {
    taskDepartmentLoadMetric: TaskDepartmentLoadMetricResponse;
    departmentId: string;
}

export class TaskDepartmentLoadMetricResponse implements ITaskDepartmentLoadMetricResponse {
    departmentLoadStatus!: DepartmentLoadStatus;
    combinedTasksWorkTimeInMinutes!: number;
    amountOfTasksOverdue!: number;

    constructor(data?: ITaskDepartmentLoadMetricResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentLoadStatus = _data["departmentLoadStatus"];
            this.combinedTasksWorkTimeInMinutes = _data["combinedTasksWorkTimeInMinutes"];
            this.amountOfTasksOverdue = _data["amountOfTasksOverdue"];
        }
    }

    static fromJS(data: any): TaskDepartmentLoadMetricResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDepartmentLoadMetricResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentLoadStatus"] = this.departmentLoadStatus;
        data["combinedTasksWorkTimeInMinutes"] = this.combinedTasksWorkTimeInMinutes;
        data["amountOfTasksOverdue"] = this.amountOfTasksOverdue;
        return data; 
    }
}

export interface ITaskDepartmentLoadMetricResponse {
    departmentLoadStatus: DepartmentLoadStatus;
    combinedTasksWorkTimeInMinutes: number;
    amountOfTasksOverdue: number;
}

export enum DepartmentLoadStatus {
    Normal = "Normal",
    Busy = "Busy",
    Stressed = "Stressed",
}

export class TaskReportMetricQueryRequest implements ITaskReportMetricQueryRequest {
    date!: moment.Moment;
    organisationIds!: string[];
    metricNames!: ReportMetricNames[];

    constructor(data?: ITaskReportMetricQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisationIds = [];
            this.metricNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["organisationIds"])) {
                this.organisationIds = [] as any;
                for (let item of _data["organisationIds"])
                    this.organisationIds!.push(item);
            }
            if (Array.isArray(_data["metricNames"])) {
                this.metricNames = [] as any;
                for (let item of _data["metricNames"])
                    this.metricNames!.push(item);
            }
        }
    }

    static fromJS(data: any): TaskReportMetricQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskReportMetricQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : <any>undefined;
        if (Array.isArray(this.organisationIds)) {
            data["organisationIds"] = [];
            for (let item of this.organisationIds)
                data["organisationIds"].push(item);
        }
        if (Array.isArray(this.metricNames)) {
            data["metricNames"] = [];
            for (let item of this.metricNames)
                data["metricNames"].push(item);
        }
        return data; 
    }
}

export interface ITaskReportMetricQueryRequest {
    date: moment.Moment;
    organisationIds: string[];
    metricNames: ReportMetricNames[];
}

export enum ReportMetricNames {
    TaskStatus = "TaskStatus",
    TaskCompletion = "TaskCompletion",
    TaskProfessions = "TaskProfessions",
    TaskDepartmentLoad = "TaskDepartmentLoad",
}

export class TaskImageResponse implements ITaskImageResponse {
    uri!: string;

    constructor(data?: ITaskImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): TaskImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        return data; 
    }
}

export interface ITaskImageResponse {
    uri: string;
}

export enum TaskImageSize {
    Thumbnail = "Thumbnail",
    Detail = "Detail",
    Hd = "Hd",
}

export class TaskAssignmentResponse implements ITaskAssignmentResponse {
    id!: string;
    residentLegacyId!: number;
    startDate!: moment.Moment;
    startTime!: string;
    endTime!: string;
    isMovedTarget!: boolean;
    repeat!: boolean;
    repeatEndType?: RepeatEndType | undefined;
    repeatEndValue?: string | undefined;
    repeatInterval!: number;
    repeatType?: RepeatType | undefined;
    standardTaskId!: string;
    weekPattern?: string | undefined;
    isAdHoc!: boolean;
    isResidentTask!: boolean;
    contactRelated!: boolean;
    description!: string;
    expectedExecutionTimeInMinutes!: number;
    medicationRelated!: boolean;
    isHealthAct!: boolean;
    delegatedProfessionId?: number | undefined;
    twoWorkers!: boolean;
    lastUpdated!: moment.Moment;
    title!: string;
    originalProfessionId!: number;
    accessControlTagIds!: string[];
    planIds!: string[];
    delegationTagIds!: string[];
    additionalRepetitionIntervals!: TaskAssignmentAdditionalRepetitionIntervalResponse[];
    associations!: TaskAssignmentAssociationsResponse;

    constructor(data?: ITaskAssignmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
            this.planIds = [];
            this.delegationTagIds = [];
            this.additionalRepetitionIntervals = [];
            this.associations = new TaskAssignmentAssociationsResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.residentLegacyId = _data["residentLegacyId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.isMovedTarget = _data["isMovedTarget"];
            this.repeat = _data["repeat"];
            this.repeatEndType = _data["repeatEndType"];
            this.repeatEndValue = _data["repeatEndValue"];
            this.repeatInterval = _data["repeatInterval"];
            this.repeatType = _data["repeatType"];
            this.standardTaskId = _data["standardTaskId"];
            this.weekPattern = _data["weekPattern"];
            this.isAdHoc = _data["isAdHoc"];
            this.isResidentTask = _data["isResidentTask"];
            this.contactRelated = _data["contactRelated"];
            this.description = _data["description"];
            this.expectedExecutionTimeInMinutes = _data["expectedExecutionTimeInMinutes"];
            this.medicationRelated = _data["medicationRelated"];
            this.isHealthAct = _data["isHealthAct"];
            this.delegatedProfessionId = _data["delegatedProfessionId"];
            this.twoWorkers = _data["twoWorkers"];
            this.lastUpdated = _data["lastUpdated"] ? moment(_data["lastUpdated"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.originalProfessionId = _data["originalProfessionId"];
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            if (Array.isArray(_data["planIds"])) {
                this.planIds = [] as any;
                for (let item of _data["planIds"])
                    this.planIds!.push(item);
            }
            if (Array.isArray(_data["delegationTagIds"])) {
                this.delegationTagIds = [] as any;
                for (let item of _data["delegationTagIds"])
                    this.delegationTagIds!.push(item);
            }
            if (Array.isArray(_data["additionalRepetitionIntervals"])) {
                this.additionalRepetitionIntervals = [] as any;
                for (let item of _data["additionalRepetitionIntervals"])
                    this.additionalRepetitionIntervals!.push(TaskAssignmentAdditionalRepetitionIntervalResponse.fromJS(item));
            }
            this.associations = _data["associations"] ? TaskAssignmentAssociationsResponse.fromJS(_data["associations"]) : new TaskAssignmentAssociationsResponse();
        }
    }

    static fromJS(data: any): TaskAssignmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssignmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["residentLegacyId"] = this.residentLegacyId;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : <any>undefined;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["isMovedTarget"] = this.isMovedTarget;
        data["repeat"] = this.repeat;
        data["repeatEndType"] = this.repeatEndType;
        data["repeatEndValue"] = this.repeatEndValue;
        data["repeatInterval"] = this.repeatInterval;
        data["repeatType"] = this.repeatType;
        data["standardTaskId"] = this.standardTaskId;
        data["weekPattern"] = this.weekPattern;
        data["isAdHoc"] = this.isAdHoc;
        data["isResidentTask"] = this.isResidentTask;
        data["contactRelated"] = this.contactRelated;
        data["description"] = this.description;
        data["expectedExecutionTimeInMinutes"] = this.expectedExecutionTimeInMinutes;
        data["medicationRelated"] = this.medicationRelated;
        data["isHealthAct"] = this.isHealthAct;
        data["delegatedProfessionId"] = this.delegatedProfessionId;
        data["twoWorkers"] = this.twoWorkers;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["originalProfessionId"] = this.originalProfessionId;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        if (Array.isArray(this.planIds)) {
            data["planIds"] = [];
            for (let item of this.planIds)
                data["planIds"].push(item);
        }
        if (Array.isArray(this.delegationTagIds)) {
            data["delegationTagIds"] = [];
            for (let item of this.delegationTagIds)
                data["delegationTagIds"].push(item);
        }
        if (Array.isArray(this.additionalRepetitionIntervals)) {
            data["additionalRepetitionIntervals"] = [];
            for (let item of this.additionalRepetitionIntervals)
                data["additionalRepetitionIntervals"].push(item.toJSON());
        }
        data["associations"] = this.associations ? this.associations.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITaskAssignmentResponse {
    id: string;
    residentLegacyId: number;
    startDate: moment.Moment;
    startTime: string;
    endTime: string;
    isMovedTarget: boolean;
    repeat: boolean;
    repeatEndType?: RepeatEndType | undefined;
    repeatEndValue?: string | undefined;
    repeatInterval: number;
    repeatType?: RepeatType | undefined;
    standardTaskId: string;
    weekPattern?: string | undefined;
    isAdHoc: boolean;
    isResidentTask: boolean;
    contactRelated: boolean;
    description: string;
    expectedExecutionTimeInMinutes: number;
    medicationRelated: boolean;
    isHealthAct: boolean;
    delegatedProfessionId?: number | undefined;
    twoWorkers: boolean;
    lastUpdated: moment.Moment;
    title: string;
    originalProfessionId: number;
    accessControlTagIds: string[];
    planIds: string[];
    delegationTagIds: string[];
    additionalRepetitionIntervals: TaskAssignmentAdditionalRepetitionIntervalResponse[];
    associations: TaskAssignmentAssociationsResponse;
}

export enum RepeatEndType {
    Never = "Never",
    Count = "Count",
    Date = "Date",
}

export enum RepeatType {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
    Yearly = "Yearly",
}

export class TaskAssignmentAdditionalRepetitionIntervalResponse implements ITaskAssignmentAdditionalRepetitionIntervalResponse {
    id!: string;
    start!: string;
    end!: string;

    constructor(data?: ITaskAssignmentAdditionalRepetitionIntervalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.start = _data["start"];
            this.end = _data["end"];
        }
    }

    static fromJS(data: any): TaskAssignmentAdditionalRepetitionIntervalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssignmentAdditionalRepetitionIntervalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["start"] = this.start;
        data["end"] = this.end;
        return data; 
    }
}

export interface ITaskAssignmentAdditionalRepetitionIntervalResponse {
    id: string;
    start: string;
    end: string;
}

export class TaskAssignmentAssociationsResponse implements ITaskAssignmentAssociationsResponse {
    associatedForms!: AssignmentFormResponse[];
    associatedInstructions!: AssignmentInstructionResponse[];
    associatedPrescription?: AssignmentPrescriptionResponse | undefined;
    standardTaskAssociatedForms!: StandardTaskAssociatedFormResponse[];

    constructor(data?: ITaskAssignmentAssociationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associatedForms = [];
            this.associatedInstructions = [];
            this.standardTaskAssociatedForms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associatedForms"])) {
                this.associatedForms = [] as any;
                for (let item of _data["associatedForms"])
                    this.associatedForms!.push(AssignmentFormResponse.fromJS(item));
            }
            if (Array.isArray(_data["associatedInstructions"])) {
                this.associatedInstructions = [] as any;
                for (let item of _data["associatedInstructions"])
                    this.associatedInstructions!.push(AssignmentInstructionResponse.fromJS(item));
            }
            this.associatedPrescription = _data["associatedPrescription"] ? AssignmentPrescriptionResponse.fromJS(_data["associatedPrescription"]) : <any>undefined;
            if (Array.isArray(_data["standardTaskAssociatedForms"])) {
                this.standardTaskAssociatedForms = [] as any;
                for (let item of _data["standardTaskAssociatedForms"])
                    this.standardTaskAssociatedForms!.push(StandardTaskAssociatedFormResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskAssignmentAssociationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssignmentAssociationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associatedForms)) {
            data["associatedForms"] = [];
            for (let item of this.associatedForms)
                data["associatedForms"].push(item.toJSON());
        }
        if (Array.isArray(this.associatedInstructions)) {
            data["associatedInstructions"] = [];
            for (let item of this.associatedInstructions)
                data["associatedInstructions"].push(item.toJSON());
        }
        data["associatedPrescription"] = this.associatedPrescription ? this.associatedPrescription.toJSON() : <any>undefined;
        if (Array.isArray(this.standardTaskAssociatedForms)) {
            data["standardTaskAssociatedForms"] = [];
            for (let item of this.standardTaskAssociatedForms)
                data["standardTaskAssociatedForms"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskAssignmentAssociationsResponse {
    associatedForms: AssignmentFormResponse[];
    associatedInstructions: AssignmentInstructionResponse[];
    associatedPrescription?: AssignmentPrescriptionResponse | undefined;
    standardTaskAssociatedForms: StandardTaskAssociatedFormResponse[];
}

export class AssignmentFormResponse implements IAssignmentFormResponse {
    formId!: string;
    required!: boolean;
    order!: number;
    paused!: boolean;

    constructor(data?: IAssignmentFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.required = _data["required"];
            this.order = _data["order"];
            this.paused = _data["paused"];
        }
    }

    static fromJS(data: any): AssignmentFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["required"] = this.required;
        data["order"] = this.order;
        data["paused"] = this.paused;
        return data; 
    }
}

export interface IAssignmentFormResponse {
    formId: string;
    required: boolean;
    order: number;
    paused: boolean;
}

export class AssignmentInstructionResponse implements IAssignmentInstructionResponse {
    instructionId!: string;
    order!: number;

    constructor(data?: IAssignmentInstructionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instructionId = _data["instructionId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): AssignmentInstructionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentInstructionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instructionId"] = this.instructionId;
        data["order"] = this.order;
        return data; 
    }
}

export interface IAssignmentInstructionResponse {
    instructionId: string;
    order: number;
}

export class AssignmentPrescriptionResponse implements IAssignmentPrescriptionResponse {
    prescriptionId?: string | undefined;

    constructor(data?: IAssignmentPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"];
        }
    }

    static fromJS(data: any): AssignmentPrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentPrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId;
        return data; 
    }
}

export interface IAssignmentPrescriptionResponse {
    prescriptionId?: string | undefined;
}

export class StandardTaskAssociatedFormResponse implements IStandardTaskAssociatedFormResponse {
    standardTaskId!: string;
    order!: number;
    formId!: string;
    required!: boolean;
    registrationId?: string | undefined;

    constructor(data?: IStandardTaskAssociatedFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardTaskId = _data["standardTaskId"];
            this.order = _data["order"];
            this.formId = _data["formId"];
            this.required = _data["required"];
            this.registrationId = _data["registrationId"];
        }
    }

    static fromJS(data: any): StandardTaskAssociatedFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskAssociatedFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId;
        data["order"] = this.order;
        data["formId"] = this.formId;
        data["required"] = this.required;
        data["registrationId"] = this.registrationId;
        return data; 
    }
}

export interface IStandardTaskAssociatedFormResponse {
    standardTaskId: string;
    order: number;
    formId: string;
    required: boolean;
    registrationId?: string | undefined;
}

export class TaskAssignmentQueryResponse implements ITaskAssignmentQueryResponse {
    id!: string;
    title!: string;
    accessControlTagIds!: string[];
    residentId!: string;
    archived!: boolean;

    constructor(data?: ITaskAssignmentQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            this.residentId = _data["residentId"];
            this.archived = _data["archived"];
        }
    }

    static fromJS(data: any): TaskAssignmentQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssignmentQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["residentId"] = this.residentId;
        data["archived"] = this.archived;
        return data; 
    }
}

export interface ITaskAssignmentQueryResponse {
    id: string;
    title: string;
    accessControlTagIds: string[];
    residentId: string;
    archived: boolean;
}

export class GetTaskAssignmentsRequest implements IGetTaskAssignmentsRequest {
    taskAssignmentIds!: string[];
    includeArchived!: boolean;

    constructor(data?: IGetTaskAssignmentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskAssignmentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taskAssignmentIds"])) {
                this.taskAssignmentIds = [] as any;
                for (let item of _data["taskAssignmentIds"])
                    this.taskAssignmentIds!.push(item);
            }
            this.includeArchived = _data["includeArchived"];
        }
    }

    static fromJS(data: any): GetTaskAssignmentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskAssignmentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskAssignmentIds)) {
            data["taskAssignmentIds"] = [];
            for (let item of this.taskAssignmentIds)
                data["taskAssignmentIds"].push(item);
        }
        data["includeArchived"] = this.includeArchived;
        return data; 
    }
}

export interface IGetTaskAssignmentsRequest {
    taskAssignmentIds: string[];
    includeArchived: boolean;
}

export class TaskAssignmentRepetitionEntriesForPeriodResponse implements ITaskAssignmentRepetitionEntriesForPeriodResponse {
    anonymousTaskAssignmentRepetitionEntries!: AnonymousTaskAssignmentRepetitionEntryResponse[];
    taskAssignmentRepetitionEntries!: TaskAssignmentRepetitionEntryResponse[];

    constructor(data?: ITaskAssignmentRepetitionEntriesForPeriodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.anonymousTaskAssignmentRepetitionEntries = [];
            this.taskAssignmentRepetitionEntries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["anonymousTaskAssignmentRepetitionEntries"])) {
                this.anonymousTaskAssignmentRepetitionEntries = [] as any;
                for (let item of _data["anonymousTaskAssignmentRepetitionEntries"])
                    this.anonymousTaskAssignmentRepetitionEntries!.push(AnonymousTaskAssignmentRepetitionEntryResponse.fromJS(item));
            }
            if (Array.isArray(_data["taskAssignmentRepetitionEntries"])) {
                this.taskAssignmentRepetitionEntries = [] as any;
                for (let item of _data["taskAssignmentRepetitionEntries"])
                    this.taskAssignmentRepetitionEntries!.push(TaskAssignmentRepetitionEntryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskAssignmentRepetitionEntriesForPeriodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssignmentRepetitionEntriesForPeriodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.anonymousTaskAssignmentRepetitionEntries)) {
            data["anonymousTaskAssignmentRepetitionEntries"] = [];
            for (let item of this.anonymousTaskAssignmentRepetitionEntries)
                data["anonymousTaskAssignmentRepetitionEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.taskAssignmentRepetitionEntries)) {
            data["taskAssignmentRepetitionEntries"] = [];
            for (let item of this.taskAssignmentRepetitionEntries)
                data["taskAssignmentRepetitionEntries"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskAssignmentRepetitionEntriesForPeriodResponse {
    anonymousTaskAssignmentRepetitionEntries: AnonymousTaskAssignmentRepetitionEntryResponse[];
    taskAssignmentRepetitionEntries: TaskAssignmentRepetitionEntryResponse[];
}

export class AnonymousTaskAssignmentRepetitionEntryResponse implements IAnonymousTaskAssignmentRepetitionEntryResponse {
    id!: string;
    residentId!: string;
    intervalStartTime!: moment.Moment;
    intervalEndTime!: moment.Moment;
    additionalRepetitionIntervals!: TaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse[];

    constructor(data?: IAnonymousTaskAssignmentRepetitionEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.additionalRepetitionIntervals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.residentId = _data["residentId"];
            this.intervalStartTime = _data["intervalStartTime"] ? moment(_data["intervalStartTime"].toString()) : <any>undefined;
            this.intervalEndTime = _data["intervalEndTime"] ? moment(_data["intervalEndTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["additionalRepetitionIntervals"])) {
                this.additionalRepetitionIntervals = [] as any;
                for (let item of _data["additionalRepetitionIntervals"])
                    this.additionalRepetitionIntervals!.push(TaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnonymousTaskAssignmentRepetitionEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnonymousTaskAssignmentRepetitionEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["residentId"] = this.residentId;
        data["intervalStartTime"] = this.intervalStartTime ? this.intervalStartTime.toISOString() : <any>undefined;
        data["intervalEndTime"] = this.intervalEndTime ? this.intervalEndTime.toISOString() : <any>undefined;
        if (Array.isArray(this.additionalRepetitionIntervals)) {
            data["additionalRepetitionIntervals"] = [];
            for (let item of this.additionalRepetitionIntervals)
                data["additionalRepetitionIntervals"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAnonymousTaskAssignmentRepetitionEntryResponse {
    id: string;
    residentId: string;
    intervalStartTime: moment.Moment;
    intervalEndTime: moment.Moment;
    additionalRepetitionIntervals: TaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse[];
}

export class TaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse implements ITaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse {
    id!: string;
    start!: moment.Moment;
    end!: moment.Moment;
    archivedAt?: moment.Moment | undefined;

    constructor(data?: ITaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.start = _data["start"] ? moment(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? moment(_data["end"].toString()) : <any>undefined;
            this.archivedAt = _data["archivedAt"] ? moment(_data["archivedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["archivedAt"] = this.archivedAt ? this.archivedAt.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ITaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse {
    id: string;
    start: moment.Moment;
    end: moment.Moment;
    archivedAt?: moment.Moment | undefined;
}

export class TaskAssignmentRepetitionEntryResponse implements ITaskAssignmentRepetitionEntryResponse {
    id!: string;
    title!: string;
    originalProfessionId!: number;
    residentId!: string;
    intervalStartTime!: moment.Moment;
    intervalEndTime!: moment.Moment;
    isMovedTarget!: boolean;
    standardTaskId!: string;
    isAdHoc!: boolean;
    isResidentTask!: boolean;
    originalTaskAssignmentId?: string | undefined;
    contactRelated!: boolean;
    description!: string;
    expectedExecutionTimeInMinutes!: number;
    medicationRelated!: boolean;
    isHealthAct!: boolean;
    delegatedProfessionId?: number | undefined;
    twoWorkers!: boolean;
    lastUpdated!: moment.Moment;
    additionalRepetitionIntervals!: TaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse[];

    constructor(data?: ITaskAssignmentRepetitionEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.additionalRepetitionIntervals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.originalProfessionId = _data["originalProfessionId"];
            this.residentId = _data["residentId"];
            this.intervalStartTime = _data["intervalStartTime"] ? moment(_data["intervalStartTime"].toString()) : <any>undefined;
            this.intervalEndTime = _data["intervalEndTime"] ? moment(_data["intervalEndTime"].toString()) : <any>undefined;
            this.isMovedTarget = _data["isMovedTarget"];
            this.standardTaskId = _data["standardTaskId"];
            this.isAdHoc = _data["isAdHoc"];
            this.isResidentTask = _data["isResidentTask"];
            this.originalTaskAssignmentId = _data["originalTaskAssignmentId"];
            this.contactRelated = _data["contactRelated"];
            this.description = _data["description"];
            this.expectedExecutionTimeInMinutes = _data["expectedExecutionTimeInMinutes"];
            this.medicationRelated = _data["medicationRelated"];
            this.isHealthAct = _data["isHealthAct"];
            this.delegatedProfessionId = _data["delegatedProfessionId"];
            this.twoWorkers = _data["twoWorkers"];
            this.lastUpdated = _data["lastUpdated"] ? moment(_data["lastUpdated"].toString()) : <any>undefined;
            if (Array.isArray(_data["additionalRepetitionIntervals"])) {
                this.additionalRepetitionIntervals = [] as any;
                for (let item of _data["additionalRepetitionIntervals"])
                    this.additionalRepetitionIntervals!.push(TaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskAssignmentRepetitionEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssignmentRepetitionEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["originalProfessionId"] = this.originalProfessionId;
        data["residentId"] = this.residentId;
        data["intervalStartTime"] = this.intervalStartTime ? this.intervalStartTime.toISOString() : <any>undefined;
        data["intervalEndTime"] = this.intervalEndTime ? this.intervalEndTime.toISOString() : <any>undefined;
        data["isMovedTarget"] = this.isMovedTarget;
        data["standardTaskId"] = this.standardTaskId;
        data["isAdHoc"] = this.isAdHoc;
        data["isResidentTask"] = this.isResidentTask;
        data["originalTaskAssignmentId"] = this.originalTaskAssignmentId;
        data["contactRelated"] = this.contactRelated;
        data["description"] = this.description;
        data["expectedExecutionTimeInMinutes"] = this.expectedExecutionTimeInMinutes;
        data["medicationRelated"] = this.medicationRelated;
        data["isHealthAct"] = this.isHealthAct;
        data["delegatedProfessionId"] = this.delegatedProfessionId;
        data["twoWorkers"] = this.twoWorkers;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        if (Array.isArray(this.additionalRepetitionIntervals)) {
            data["additionalRepetitionIntervals"] = [];
            for (let item of this.additionalRepetitionIntervals)
                data["additionalRepetitionIntervals"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITaskAssignmentRepetitionEntryResponse {
    id: string;
    title: string;
    originalProfessionId: number;
    residentId: string;
    intervalStartTime: moment.Moment;
    intervalEndTime: moment.Moment;
    isMovedTarget: boolean;
    standardTaskId: string;
    isAdHoc: boolean;
    isResidentTask: boolean;
    originalTaskAssignmentId?: string | undefined;
    contactRelated: boolean;
    description: string;
    expectedExecutionTimeInMinutes: number;
    medicationRelated: boolean;
    isHealthAct: boolean;
    delegatedProfessionId?: number | undefined;
    twoWorkers: boolean;
    lastUpdated: moment.Moment;
    additionalRepetitionIntervals: TaskAssignmentRepetitionEntryAdditionalRepetitionIntervalResponse[];
}

export class GetTaskAssignmentsForPeriodRequest implements IGetTaskAssignmentsForPeriodRequest {
    residentIds!: string[];
    from!: moment.Moment;
    to!: moment.Moment;

    constructor(data?: IGetTaskAssignmentsForPeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskAssignmentsForPeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskAssignmentsForPeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["from"] = this.from ? this.from.format('YYYY-MM-DD') : <any>undefined;
        data["to"] = this.to ? this.to.format('YYYY-MM-DD') : <any>undefined;
        return data; 
    }
}

export interface IGetTaskAssignmentsForPeriodRequest {
    residentIds: string[];
    from: moment.Moment;
    to: moment.Moment;
}

export class TaskAssignmentNextOccurrenceResponse implements ITaskAssignmentNextOccurrenceResponse {
    id!: string;
    title?: string | undefined;
    standardTaskId!: string;
    startDate!: moment.Moment;
    nextDate!: moment.Moment;
    description?: string | undefined;
    repeat!: boolean;
    repeatEndType?: RepeatEndType | undefined;
    repeatEndValue?: string | undefined;
    repeatInterval!: number;
    repeatType?: RepeatType | undefined;
    weekPattern?: string | undefined;

    constructor(data?: ITaskAssignmentNextOccurrenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.standardTaskId = _data["standardTaskId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.nextDate = _data["nextDate"] ? moment(_data["nextDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.repeat = _data["repeat"];
            this.repeatEndType = _data["repeatEndType"];
            this.repeatEndValue = _data["repeatEndValue"];
            this.repeatInterval = _data["repeatInterval"];
            this.repeatType = _data["repeatType"];
            this.weekPattern = _data["weekPattern"];
        }
    }

    static fromJS(data: any): TaskAssignmentNextOccurrenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssignmentNextOccurrenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["standardTaskId"] = this.standardTaskId;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : <any>undefined;
        data["nextDate"] = this.nextDate ? this.nextDate.format('YYYY-MM-DD') : <any>undefined;
        data["description"] = this.description;
        data["repeat"] = this.repeat;
        data["repeatEndType"] = this.repeatEndType;
        data["repeatEndValue"] = this.repeatEndValue;
        data["repeatInterval"] = this.repeatInterval;
        data["repeatType"] = this.repeatType;
        data["weekPattern"] = this.weekPattern;
        return data; 
    }
}

export interface ITaskAssignmentNextOccurrenceResponse {
    id: string;
    title?: string | undefined;
    standardTaskId: string;
    startDate: moment.Moment;
    nextDate: moment.Moment;
    description?: string | undefined;
    repeat: boolean;
    repeatEndType?: RepeatEndType | undefined;
    repeatEndValue?: string | undefined;
    repeatInterval: number;
    repeatType?: RepeatType | undefined;
    weekPattern?: string | undefined;
}

export class StandardTaskRestEntity implements IStandardTaskRestEntity {
    canCreateAdHoc!: boolean;
    canMove!: boolean;
    canCancel!: boolean;
    categoryIds!: string[];
    tagIds!: string[];
    accessControlTagIds!: string[];
    description!: string;
    durationInMinutes!: number;
    id!: string;
    isContactPersonRelated!: boolean;
    isMedicationRelated!: boolean;
    lamport!: number;
    owningOrganisationId!: string;
    professionId?: string | undefined;
    requiresTwoWorkers!: boolean;
    includeTaskNotCompletedOnTimeInRecord!: boolean;
    title!: string;
    associatedPlanIds!: string[];
    associatedNexusVumSubGoalIds!: string[];
    isDeleted!: boolean;
    trimmedId!: string;

    constructor(data?: IStandardTaskRestEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
            this.tagIds = [];
            this.accessControlTagIds = [];
            this.associatedPlanIds = [];
            this.associatedNexusVumSubGoalIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canCreateAdHoc = _data["canCreateAdHoc"];
            this.canMove = _data["canMove"];
            this.canCancel = _data["canCancel"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            this.description = _data["description"];
            this.durationInMinutes = _data["durationInMinutes"];
            this.id = _data["id"];
            this.isContactPersonRelated = _data["isContactPersonRelated"];
            this.isMedicationRelated = _data["isMedicationRelated"];
            this.lamport = _data["lamport"];
            this.owningOrganisationId = _data["owningOrganisationId"];
            this.professionId = _data["professionId"];
            this.requiresTwoWorkers = _data["requiresTwoWorkers"];
            this.includeTaskNotCompletedOnTimeInRecord = _data["includeTaskNotCompletedOnTimeInRecord"];
            this.title = _data["title"];
            if (Array.isArray(_data["associatedPlanIds"])) {
                this.associatedPlanIds = [] as any;
                for (let item of _data["associatedPlanIds"])
                    this.associatedPlanIds!.push(item);
            }
            if (Array.isArray(_data["associatedNexusVumSubGoalIds"])) {
                this.associatedNexusVumSubGoalIds = [] as any;
                for (let item of _data["associatedNexusVumSubGoalIds"])
                    this.associatedNexusVumSubGoalIds!.push(item);
            }
            this.isDeleted = _data["isDeleted"];
            this.trimmedId = _data["trimmedId"];
        }
    }

    static fromJS(data: any): StandardTaskRestEntity {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskRestEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canCreateAdHoc"] = this.canCreateAdHoc;
        data["canMove"] = this.canMove;
        data["canCancel"] = this.canCancel;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["description"] = this.description;
        data["durationInMinutes"] = this.durationInMinutes;
        data["id"] = this.id;
        data["isContactPersonRelated"] = this.isContactPersonRelated;
        data["isMedicationRelated"] = this.isMedicationRelated;
        data["lamport"] = this.lamport;
        data["owningOrganisationId"] = this.owningOrganisationId;
        data["professionId"] = this.professionId;
        data["requiresTwoWorkers"] = this.requiresTwoWorkers;
        data["includeTaskNotCompletedOnTimeInRecord"] = this.includeTaskNotCompletedOnTimeInRecord;
        data["title"] = this.title;
        if (Array.isArray(this.associatedPlanIds)) {
            data["associatedPlanIds"] = [];
            for (let item of this.associatedPlanIds)
                data["associatedPlanIds"].push(item);
        }
        if (Array.isArray(this.associatedNexusVumSubGoalIds)) {
            data["associatedNexusVumSubGoalIds"] = [];
            for (let item of this.associatedNexusVumSubGoalIds)
                data["associatedNexusVumSubGoalIds"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["trimmedId"] = this.trimmedId;
        return data; 
    }
}

export interface IStandardTaskRestEntity {
    canCreateAdHoc: boolean;
    canMove: boolean;
    canCancel: boolean;
    categoryIds: string[];
    tagIds: string[];
    accessControlTagIds: string[];
    description: string;
    durationInMinutes: number;
    id: string;
    isContactPersonRelated: boolean;
    isMedicationRelated: boolean;
    lamport: number;
    owningOrganisationId: string;
    professionId?: string | undefined;
    requiresTwoWorkers: boolean;
    includeTaskNotCompletedOnTimeInRecord: boolean;
    title: string;
    associatedPlanIds: string[];
    associatedNexusVumSubGoalIds: string[];
    isDeleted: boolean;
    trimmedId: string;
}

export class GetStandardTasksByIdsRequest implements IGetStandardTasksByIdsRequest {
    customerId!: string;
    standardTaskIds!: string[];

    constructor(data?: IGetStandardTasksByIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.standardTaskIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["standardTaskIds"])) {
                this.standardTaskIds = [] as any;
                for (let item of _data["standardTaskIds"])
                    this.standardTaskIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetStandardTasksByIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStandardTasksByIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        if (Array.isArray(this.standardTaskIds)) {
            data["standardTaskIds"] = [];
            for (let item of this.standardTaskIds)
                data["standardTaskIds"].push(item);
        }
        return data; 
    }
}

export interface IGetStandardTasksByIdsRequest {
    customerId: string;
    standardTaskIds: string[];
}

export class MinimalPackageInfo implements IMinimalPackageInfo {
    trackTraceId?: string | undefined;

    constructor(data?: IMinimalPackageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackTraceId = _data["trackTraceId"];
        }
    }

    static fromJS(data: any): MinimalPackageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MinimalPackageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackTraceId"] = this.trackTraceId;
        return data; 
    }
}

export interface IMinimalPackageInfo {
    trackTraceId?: string | undefined;
}

export class UpdateStandardTaskRequest implements IUpdateStandardTaskRequest {
    canCreateAdHoc!: boolean;
    canMove!: boolean;
    canCancel!: boolean;
    categoryIds!: string[];
    tagIds!: string[];
    accessControlTagIds!: string[];
    description?: string | undefined;
    durationInMinutes!: number;
    isContactPersonRelated!: boolean;
    isMedicationRelated!: boolean;
    lamport!: number;
    professionId!: number;
    requiresTwoWorkers!: boolean;
    includeTaskNotCompletedOnTimeInRecord!: boolean;
    title!: string;

    constructor(data?: IUpdateStandardTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
            this.tagIds = [];
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canCreateAdHoc = _data["canCreateAdHoc"];
            this.canMove = _data["canMove"];
            this.canCancel = _data["canCancel"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            this.description = _data["description"];
            this.durationInMinutes = _data["durationInMinutes"];
            this.isContactPersonRelated = _data["isContactPersonRelated"];
            this.isMedicationRelated = _data["isMedicationRelated"];
            this.lamport = _data["lamport"];
            this.professionId = _data["professionId"];
            this.requiresTwoWorkers = _data["requiresTwoWorkers"];
            this.includeTaskNotCompletedOnTimeInRecord = _data["includeTaskNotCompletedOnTimeInRecord"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateStandardTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStandardTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canCreateAdHoc"] = this.canCreateAdHoc;
        data["canMove"] = this.canMove;
        data["canCancel"] = this.canCancel;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["description"] = this.description;
        data["durationInMinutes"] = this.durationInMinutes;
        data["isContactPersonRelated"] = this.isContactPersonRelated;
        data["isMedicationRelated"] = this.isMedicationRelated;
        data["lamport"] = this.lamport;
        data["professionId"] = this.professionId;
        data["requiresTwoWorkers"] = this.requiresTwoWorkers;
        data["includeTaskNotCompletedOnTimeInRecord"] = this.includeTaskNotCompletedOnTimeInRecord;
        data["title"] = this.title;
        return data; 
    }
}

export interface IUpdateStandardTaskRequest {
    canCreateAdHoc: boolean;
    canMove: boolean;
    canCancel: boolean;
    categoryIds: string[];
    tagIds: string[];
    accessControlTagIds: string[];
    description?: string | undefined;
    durationInMinutes: number;
    isContactPersonRelated: boolean;
    isMedicationRelated: boolean;
    lamport: number;
    professionId: number;
    requiresTwoWorkers: boolean;
    includeTaskNotCompletedOnTimeInRecord: boolean;
    title: string;
}

export class GetStandardTasksAssociatedWithIdsBatchRequest implements IGetStandardTasksAssociatedWithIdsBatchRequest {
    associatedWithIds!: string[];
    includeDeleted!: boolean;

    constructor(data?: IGetStandardTasksAssociatedWithIdsBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associatedWithIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associatedWithIds"])) {
                this.associatedWithIds = [] as any;
                for (let item of _data["associatedWithIds"])
                    this.associatedWithIds!.push(item);
            }
            this.includeDeleted = _data["includeDeleted"];
        }
    }

    static fromJS(data: any): GetStandardTasksAssociatedWithIdsBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStandardTasksAssociatedWithIdsBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associatedWithIds)) {
            data["associatedWithIds"] = [];
            for (let item of this.associatedWithIds)
                data["associatedWithIds"].push(item);
        }
        data["includeDeleted"] = this.includeDeleted;
        return data; 
    }
}

export interface IGetStandardTasksAssociatedWithIdsBatchRequest {
    associatedWithIds: string[];
    includeDeleted: boolean;
}

export class CreateStandardTaskResponse extends MinimalPackageInfo implements ICreateStandardTaskResponse {
    standardTaskId!: string;

    constructor(data?: ICreateStandardTaskResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.standardTaskId = _data["standardTaskId"];
        }
    }

    static fromJS(data: any): CreateStandardTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStandardTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId;
        super.toJSON(data);
        return data; 
    }
}

export interface ICreateStandardTaskResponse extends IMinimalPackageInfo {
    standardTaskId: string;
}

export class CreateStandardTaskRequest implements ICreateStandardTaskRequest {
    canCreateAdHoc!: boolean;
    canMove!: boolean;
    canCancel!: boolean;
    description!: string;
    durationInMinutes!: number;
    isContactPersonRelated!: boolean;
    isMedicationRelated!: boolean;
    professionId!: number;
    requiresTwoWorkers!: boolean;
    includeTaskNotCompletedOnTimeInRecord!: boolean;
    title!: string;
    categoryIds!: string[];
    tagIds!: string[];
    accessControlTagIds!: string[];

    constructor(data?: ICreateStandardTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
            this.tagIds = [];
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canCreateAdHoc = _data["canCreateAdHoc"];
            this.canMove = _data["canMove"];
            this.canCancel = _data["canCancel"];
            this.description = _data["description"];
            this.durationInMinutes = _data["durationInMinutes"];
            this.isContactPersonRelated = _data["isContactPersonRelated"];
            this.isMedicationRelated = _data["isMedicationRelated"];
            this.professionId = _data["professionId"];
            this.requiresTwoWorkers = _data["requiresTwoWorkers"];
            this.includeTaskNotCompletedOnTimeInRecord = _data["includeTaskNotCompletedOnTimeInRecord"];
            this.title = _data["title"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateStandardTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStandardTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canCreateAdHoc"] = this.canCreateAdHoc;
        data["canMove"] = this.canMove;
        data["canCancel"] = this.canCancel;
        data["description"] = this.description;
        data["durationInMinutes"] = this.durationInMinutes;
        data["isContactPersonRelated"] = this.isContactPersonRelated;
        data["isMedicationRelated"] = this.isMedicationRelated;
        data["professionId"] = this.professionId;
        data["requiresTwoWorkers"] = this.requiresTwoWorkers;
        data["includeTaskNotCompletedOnTimeInRecord"] = this.includeTaskNotCompletedOnTimeInRecord;
        data["title"] = this.title;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateStandardTaskRequest {
    canCreateAdHoc: boolean;
    canMove: boolean;
    canCancel: boolean;
    description: string;
    durationInMinutes: number;
    isContactPersonRelated: boolean;
    isMedicationRelated: boolean;
    professionId: number;
    requiresTwoWorkers: boolean;
    includeTaskNotCompletedOnTimeInRecord: boolean;
    title: string;
    categoryIds: string[];
    tagIds: string[];
    accessControlTagIds: string[];
}

export class DeleteStandardTaskRequest implements IDeleteStandardTaskRequest {
    lamport!: number;

    constructor(data?: IDeleteStandardTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lamport = _data["lamport"];
        }
    }

    static fromJS(data: any): DeleteStandardTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStandardTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lamport"] = this.lamport;
        return data; 
    }
}

export interface IDeleteStandardTaskRequest {
    lamport: number;
}

export class StandardTasksHistoryResponse implements IStandardTasksHistoryResponse {
    standardTaskId!: string;
    taskVersions!: StandardTaskVersionResponse[];

    constructor(data?: IStandardTasksHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskVersions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardTaskId = _data["standardTaskId"];
            if (Array.isArray(_data["taskVersions"])) {
                this.taskVersions = [] as any;
                for (let item of _data["taskVersions"])
                    this.taskVersions!.push(StandardTaskVersionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StandardTasksHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTasksHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId;
        if (Array.isArray(this.taskVersions)) {
            data["taskVersions"] = [];
            for (let item of this.taskVersions)
                data["taskVersions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStandardTasksHistoryResponse {
    standardTaskId: string;
    taskVersions: StandardTaskVersionResponse[];
}

export class StandardTaskVersionResponse implements IStandardTaskVersionResponse {
    beginTime!: moment.Moment;
    task!: StandardTaskRestEntity;

    constructor(data?: IStandardTaskVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.task = new StandardTaskRestEntity();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beginTime = _data["beginTime"] ? moment(_data["beginTime"].toString()) : <any>undefined;
            this.task = _data["task"] ? StandardTaskRestEntity.fromJS(_data["task"]) : new StandardTaskRestEntity();
        }
    }

    static fromJS(data: any): StandardTaskVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : <any>undefined;
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IStandardTaskVersionResponse {
    beginTime: moment.Moment;
    task: StandardTaskRestEntity;
}

export class QueryStandardTasksHistoryRequest implements IQueryStandardTasksHistoryRequest {
    standardTaskIds!: string[];
    from!: moment.Moment;
    to!: moment.Moment;

    constructor(data?: IQueryStandardTasksHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.standardTaskIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["standardTaskIds"])) {
                this.standardTaskIds = [] as any;
                for (let item of _data["standardTaskIds"])
                    this.standardTaskIds!.push(item);
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QueryStandardTasksHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QueryStandardTasksHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.standardTaskIds)) {
            data["standardTaskIds"] = [];
            for (let item of this.standardTaskIds)
                data["standardTaskIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IQueryStandardTasksHistoryRequest {
    standardTaskIds: string[];
    from: moment.Moment;
    to: moment.Moment;
}

export class NexusVumSubGoalAssociationsUpdatedResponse implements INexusVumSubGoalAssociationsUpdatedResponse {
    standardTaskAssociatedResults!: StandardTaskAssociationUpdatedResult[];
    trackTraceIds!: string[];

    constructor(data?: INexusVumSubGoalAssociationsUpdatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.standardTaskAssociatedResults = [];
            this.trackTraceIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["standardTaskAssociatedResults"])) {
                this.standardTaskAssociatedResults = [] as any;
                for (let item of _data["standardTaskAssociatedResults"])
                    this.standardTaskAssociatedResults!.push(StandardTaskAssociationUpdatedResult.fromJS(item));
            }
            if (Array.isArray(_data["trackTraceIds"])) {
                this.trackTraceIds = [] as any;
                for (let item of _data["trackTraceIds"])
                    this.trackTraceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): NexusVumSubGoalAssociationsUpdatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NexusVumSubGoalAssociationsUpdatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.standardTaskAssociatedResults)) {
            data["standardTaskAssociatedResults"] = [];
            for (let item of this.standardTaskAssociatedResults)
                data["standardTaskAssociatedResults"].push(item.toJSON());
        }
        if (Array.isArray(this.trackTraceIds)) {
            data["trackTraceIds"] = [];
            for (let item of this.trackTraceIds)
                data["trackTraceIds"].push(item);
        }
        return data; 
    }
}

export interface INexusVumSubGoalAssociationsUpdatedResponse {
    standardTaskAssociatedResults: StandardTaskAssociationUpdatedResult[];
    trackTraceIds: string[];
}

export class StandardTaskAssociationUpdatedResult implements IStandardTaskAssociationUpdatedResult {
    standardTaskId!: string;
    success!: boolean;

    constructor(data?: IStandardTaskAssociationUpdatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardTaskId = _data["standardTaskId"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): StandardTaskAssociationUpdatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskAssociationUpdatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId;
        data["success"] = this.success;
        return data; 
    }
}

export interface IStandardTaskAssociationUpdatedResult {
    standardTaskId: string;
    success: boolean;
}

export class UpdateNexusVumSubGoalAssociationsRequest implements IUpdateNexusVumSubGoalAssociationsRequest {
    standardTasksToAdd!: StandardTaskIdAndLamportTimestampRequest[];
    standardTasksToRemove!: StandardTaskIdAndLamportTimestampRequest[];

    constructor(data?: IUpdateNexusVumSubGoalAssociationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.standardTasksToAdd = [];
            this.standardTasksToRemove = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["standardTasksToAdd"])) {
                this.standardTasksToAdd = [] as any;
                for (let item of _data["standardTasksToAdd"])
                    this.standardTasksToAdd!.push(StandardTaskIdAndLamportTimestampRequest.fromJS(item));
            }
            if (Array.isArray(_data["standardTasksToRemove"])) {
                this.standardTasksToRemove = [] as any;
                for (let item of _data["standardTasksToRemove"])
                    this.standardTasksToRemove!.push(StandardTaskIdAndLamportTimestampRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNexusVumSubGoalAssociationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNexusVumSubGoalAssociationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.standardTasksToAdd)) {
            data["standardTasksToAdd"] = [];
            for (let item of this.standardTasksToAdd)
                data["standardTasksToAdd"].push(item.toJSON());
        }
        if (Array.isArray(this.standardTasksToRemove)) {
            data["standardTasksToRemove"] = [];
            for (let item of this.standardTasksToRemove)
                data["standardTasksToRemove"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateNexusVumSubGoalAssociationsRequest {
    standardTasksToAdd: StandardTaskIdAndLamportTimestampRequest[];
    standardTasksToRemove: StandardTaskIdAndLamportTimestampRequest[];
}

export class StandardTaskIdAndLamportTimestampRequest implements IStandardTaskIdAndLamportTimestampRequest {
    standardTaskId!: string;
    lamportTimeStamp!: number;

    constructor(data?: IStandardTaskIdAndLamportTimestampRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardTaskId = _data["standardTaskId"];
            this.lamportTimeStamp = _data["lamportTimeStamp"];
        }
    }

    static fromJS(data: any): StandardTaskIdAndLamportTimestampRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskIdAndLamportTimestampRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId;
        data["lamportTimeStamp"] = this.lamportTimeStamp;
        return data; 
    }
}

export interface IStandardTaskIdAndLamportTimestampRequest {
    standardTaskId: string;
    lamportTimeStamp: number;
}

export class CreateAndDeleteAssociationBatchResponse implements ICreateAndDeleteAssociationBatchResponse {
    resultForStandardTask!: AssociationResultResponse[];
    trackTraceId!: string[];

    constructor(data?: ICreateAndDeleteAssociationBatchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.resultForStandardTask = [];
            this.trackTraceId = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resultForStandardTask"])) {
                this.resultForStandardTask = [] as any;
                for (let item of _data["resultForStandardTask"])
                    this.resultForStandardTask!.push(AssociationResultResponse.fromJS(item));
            }
            if (Array.isArray(_data["trackTraceId"])) {
                this.trackTraceId = [] as any;
                for (let item of _data["trackTraceId"])
                    this.trackTraceId!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateAndDeleteAssociationBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAndDeleteAssociationBatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resultForStandardTask)) {
            data["resultForStandardTask"] = [];
            for (let item of this.resultForStandardTask)
                data["resultForStandardTask"].push(item.toJSON());
        }
        if (Array.isArray(this.trackTraceId)) {
            data["trackTraceId"] = [];
            for (let item of this.trackTraceId)
                data["trackTraceId"].push(item);
        }
        return data; 
    }
}

export interface ICreateAndDeleteAssociationBatchResponse {
    resultForStandardTask: AssociationResultResponse[];
    trackTraceId: string[];
}

export class AssociationResultResponse implements IAssociationResultResponse {
    standardTaskId!: string;
    success!: boolean;

    constructor(data?: IAssociationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardTaskId = _data["standardTaskId"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): AssociationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssociationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardTaskId"] = this.standardTaskId;
        data["success"] = this.success;
        return data; 
    }
}

export interface IAssociationResultResponse {
    standardTaskId: string;
    success: boolean;
}

export class UpdatePlanAssociationsRequest implements IUpdatePlanAssociationsRequest {
    addStandardTaskIds!: StandardTaskIdAndLamportTimestampRequest[];
    removeStandardTaskIds!: StandardTaskIdAndLamportTimestampRequest[];

    constructor(data?: IUpdatePlanAssociationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.addStandardTaskIds = [];
            this.removeStandardTaskIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addStandardTaskIds"])) {
                this.addStandardTaskIds = [] as any;
                for (let item of _data["addStandardTaskIds"])
                    this.addStandardTaskIds!.push(StandardTaskIdAndLamportTimestampRequest.fromJS(item));
            }
            if (Array.isArray(_data["removeStandardTaskIds"])) {
                this.removeStandardTaskIds = [] as any;
                for (let item of _data["removeStandardTaskIds"])
                    this.removeStandardTaskIds!.push(StandardTaskIdAndLamportTimestampRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePlanAssociationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlanAssociationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addStandardTaskIds)) {
            data["addStandardTaskIds"] = [];
            for (let item of this.addStandardTaskIds)
                data["addStandardTaskIds"].push(item.toJSON());
        }
        if (Array.isArray(this.removeStandardTaskIds)) {
            data["removeStandardTaskIds"] = [];
            for (let item of this.removeStandardTaskIds)
                data["removeStandardTaskIds"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdatePlanAssociationsRequest {
    addStandardTaskIds: StandardTaskIdAndLamportTimestampRequest[];
    removeStandardTaskIds: StandardTaskIdAndLamportTimestampRequest[];
}

export class GetStandardTasksAssociatedWithPlanIdsBatchRequest implements IGetStandardTasksAssociatedWithPlanIdsBatchRequest {
    associatedPlanIds!: string[];
    includeDeleted!: boolean;

    constructor(data?: IGetStandardTasksAssociatedWithPlanIdsBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associatedPlanIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associatedPlanIds"])) {
                this.associatedPlanIds = [] as any;
                for (let item of _data["associatedPlanIds"])
                    this.associatedPlanIds!.push(item);
            }
            this.includeDeleted = _data["includeDeleted"];
        }
    }

    static fromJS(data: any): GetStandardTasksAssociatedWithPlanIdsBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStandardTasksAssociatedWithPlanIdsBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associatedPlanIds)) {
            data["associatedPlanIds"] = [];
            for (let item of this.associatedPlanIds)
                data["associatedPlanIds"].push(item);
        }
        data["includeDeleted"] = this.includeDeleted;
        return data; 
    }
}

export interface IGetStandardTasksAssociatedWithPlanIdsBatchRequest {
    associatedPlanIds: string[];
    includeDeleted: boolean;
}

export class GetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest implements IGetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest {
    associatedNexusVumSubGoalIds!: string[];
    includeDeleted!: boolean;

    constructor(data?: IGetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associatedNexusVumSubGoalIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associatedNexusVumSubGoalIds"])) {
                this.associatedNexusVumSubGoalIds = [] as any;
                for (let item of _data["associatedNexusVumSubGoalIds"])
                    this.associatedNexusVumSubGoalIds!.push(item);
            }
            this.includeDeleted = _data["includeDeleted"];
        }
    }

    static fromJS(data: any): GetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associatedNexusVumSubGoalIds)) {
            data["associatedNexusVumSubGoalIds"] = [];
            for (let item of this.associatedNexusVumSubGoalIds)
                data["associatedNexusVumSubGoalIds"].push(item);
        }
        data["includeDeleted"] = this.includeDeleted;
        return data; 
    }
}

export interface IGetStandardTasksAssociatedWithNexusVumSubGoalIdsBatchRequest {
    associatedNexusVumSubGoalIds: string[];
    includeDeleted: boolean;
}

export class UpdateAssociatedFormsRequest implements IUpdateAssociatedFormsRequest {
    forms!: StandardTaskFormRequest[];

    constructor(data?: IUpdateAssociatedFormsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.forms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(StandardTaskFormRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAssociatedFormsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssociatedFormsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateAssociatedFormsRequest {
    forms: StandardTaskFormRequest[];
}

export class StandardTaskFormRequest implements IStandardTaskFormRequest {
    formId!: string;
    required!: boolean;
    order!: number;

    constructor(data?: IStandardTaskFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.required = _data["required"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): StandardTaskFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StandardTaskFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["required"] = this.required;
        data["order"] = this.order;
        return data; 
    }
}

export interface IStandardTaskFormRequest {
    formId: string;
    required: boolean;
    order: number;
}

export class AuditResponse implements IAuditResponse {
    valueType!: AuditType;
    executedById!: string;
    timeStamp!: moment.Moment;
    oldValue!: AuditResponseObject;
    newValue!: AuditResponseObject;

    constructor(data?: IAuditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueType = _data["valueType"];
            this.executedById = _data["executedById"];
            this.timeStamp = _data["timeStamp"] ? moment(_data["timeStamp"].toString()) : <any>undefined;
            this.oldValue = _data["oldValue"] ? AuditResponseObject.fromJS(_data["oldValue"]) : <any>undefined;
            this.newValue = _data["newValue"] ? AuditResponseObject.fromJS(_data["newValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueType"] = this.valueType;
        data["executedById"] = this.executedById;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["oldValue"] = this.oldValue ? this.oldValue.toJSON() : <any>undefined;
        data["newValue"] = this.newValue ? this.newValue.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAuditResponse {
    valueType: AuditType;
    executedById: string;
    timeStamp: moment.Moment;
    oldValue: AuditResponseObject;
    newValue: AuditResponseObject;
}

export enum AuditType {
    Unknown = "Unknown",
    Instructions = "Instructions",
    Forms = "Forms",
    Description = "Description",
    TaskType = "TaskType",
    ExecutionInterval = "ExecutionInterval",
    RecurrencePattern = "RecurrencePattern",
    Professions = "Professions",
    TaskAssignment = "TaskAssignment",
    AdditionalRepetitionIntervals = "AdditionalRepetitionIntervals",
    Prescriptions = "Prescriptions",
}

export abstract class AuditResponseObject implements IAuditResponseObject {

    protected _discriminator: string;

    constructor(data?: IAuditResponseObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AuditResponseObject";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AuditResponseObject {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "AuditLogDescriptionResponse") {
            let result = new AuditLogDescriptionResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogExecutionIntervalResponse") {
            let result = new AuditLogExecutionIntervalResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogFormResponse") {
            let result = new AuditLogFormResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogInstructionResponse") {
            let result = new AuditLogInstructionResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogPrescriptionResponse") {
            let result = new AuditLogPrescriptionResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogProfessionResponse") {
            let result = new AuditLogProfessionResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogRecurrencePatternResponse") {
            let result = new AuditLogRecurrencePatternResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "WeeklyRepetitionPatternResponse") {
            let result = new WeeklyRepetitionPatternResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogTaskTypeResponse") {
            let result = new AuditLogTaskTypeResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogTaskAssignmentResponse") {
            let result = new AuditLogTaskAssignmentResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AuditLogAdditionalRepetitionIntervalsResponse") {
            let result = new AuditLogAdditionalRepetitionIntervalsResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AuditResponseObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator; 
        return data; 
    }
}

export interface IAuditResponseObject {
}

export class AuditLogDescriptionResponse extends AuditResponseObject implements IAuditLogDescriptionResponse {
    description!: string;

    constructor(data?: IAuditLogDescriptionResponse) {
        super(data);
        this._discriminator = "AuditLogDescriptionResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AuditLogDescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogDescriptionResponse extends IAuditResponseObject {
    description: string;
}

export class AuditLogExecutionIntervalResponse extends AuditResponseObject implements IAuditLogExecutionIntervalResponse {
    startHour!: string;
    endHour!: string;
    expectedExecutionTime!: number;

    constructor(data?: IAuditLogExecutionIntervalResponse) {
        super(data);
        this._discriminator = "AuditLogExecutionIntervalResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startHour = _data["startHour"];
            this.endHour = _data["endHour"];
            this.expectedExecutionTime = _data["expectedExecutionTime"];
        }
    }

    static fromJS(data: any): AuditLogExecutionIntervalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogExecutionIntervalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startHour"] = this.startHour;
        data["endHour"] = this.endHour;
        data["expectedExecutionTime"] = this.expectedExecutionTime;
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogExecutionIntervalResponse extends IAuditResponseObject {
    startHour: string;
    endHour: string;
    expectedExecutionTime: number;
}

export class AuditLogFormResponse extends AuditResponseObject implements IAuditLogFormResponse {
    forms!: FormResponse[];

    constructor(data?: IAuditLogFormResponse) {
        super(data);
        if (!data) {
            this.forms = [];
        }
        this._discriminator = "AuditLogFormResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(FormResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditLogFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogFormResponse extends IAuditResponseObject {
    forms: FormResponse[];
}

export class FormResponse implements IFormResponse {
    id!: string;
    order!: number;
    required!: boolean;

    constructor(data?: IFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): FormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["required"] = this.required;
        return data; 
    }
}

export interface IFormResponse {
    id: string;
    order: number;
    required: boolean;
}

export class AuditLogInstructionResponse extends AuditResponseObject implements IAuditLogInstructionResponse {
    instructions!: InstructionResponse[];

    constructor(data?: IAuditLogInstructionResponse) {
        super(data);
        if (!data) {
            this.instructions = [];
        }
        this._discriminator = "AuditLogInstructionResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(InstructionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditLogInstructionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogInstructionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogInstructionResponse extends IAuditResponseObject {
    instructions: InstructionResponse[];
}

export class InstructionResponse implements IInstructionResponse {
    id!: string;
    order!: number;

    constructor(data?: IInstructionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): InstructionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        return data; 
    }
}

export interface IInstructionResponse {
    id: string;
    order: number;
}

export class AuditLogPrescriptionResponse extends AuditResponseObject implements IAuditLogPrescriptionResponse {
    prescription!: PrescriptionResponse;

    constructor(data?: IAuditLogPrescriptionResponse) {
        super(data);
        if (!data) {
            this.prescription = new PrescriptionResponse();
        }
        this._discriminator = "AuditLogPrescriptionResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.prescription = _data["prescription"] ? PrescriptionResponse.fromJS(_data["prescription"]) : new PrescriptionResponse();
        }
    }

    static fromJS(data: any): AuditLogPrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogPrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescription"] = this.prescription ? this.prescription.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogPrescriptionResponse extends IAuditResponseObject {
    prescription: PrescriptionResponse;
}

export class PrescriptionResponse implements IPrescriptionResponse {
    id!: string;

    constructor(data?: IPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrescriptionResponse {
    id: string;
}

export class AuditLogProfessionResponse extends AuditResponseObject implements IAuditLogProfessionResponse {
    selectedProfessionIds!: number[];

    constructor(data?: IAuditLogProfessionResponse) {
        super(data);
        if (!data) {
            this.selectedProfessionIds = [];
        }
        this._discriminator = "AuditLogProfessionResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["selectedProfessionIds"])) {
                this.selectedProfessionIds = [] as any;
                for (let item of _data["selectedProfessionIds"])
                    this.selectedProfessionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AuditLogProfessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogProfessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedProfessionIds)) {
            data["selectedProfessionIds"] = [];
            for (let item of this.selectedProfessionIds)
                data["selectedProfessionIds"].push(item);
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogProfessionResponse extends IAuditResponseObject {
    selectedProfessionIds: number[];
}

export class AuditLogRecurrencePatternResponse extends AuditResponseObject implements IAuditLogRecurrencePatternResponse {
    repeat!: boolean;
    repeatEndType!: string;
    repeatEndValue!: string;
    repeatType!: string;
    repeatInterval!: number;
    weeklyRepetitionPattern!: WeeklyRepetitionPatternResponse;

    constructor(data?: IAuditLogRecurrencePatternResponse) {
        super(data);
        if (!data) {
            this.weeklyRepetitionPattern = new WeeklyRepetitionPatternResponse();
        }
        this._discriminator = "AuditLogRecurrencePatternResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.repeat = _data["repeat"];
            this.repeatEndType = _data["repeatEndType"];
            this.repeatEndValue = _data["repeatEndValue"];
            this.repeatType = _data["repeatType"];
            this.repeatInterval = _data["repeatInterval"];
            this.weeklyRepetitionPattern = _data["weeklyRepetitionPattern"] ? WeeklyRepetitionPatternResponse.fromJS(_data["weeklyRepetitionPattern"]) : new WeeklyRepetitionPatternResponse();
        }
    }

    static fromJS(data: any): AuditLogRecurrencePatternResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogRecurrencePatternResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repeat"] = this.repeat;
        data["repeatEndType"] = this.repeatEndType;
        data["repeatEndValue"] = this.repeatEndValue;
        data["repeatType"] = this.repeatType;
        data["repeatInterval"] = this.repeatInterval;
        data["weeklyRepetitionPattern"] = this.weeklyRepetitionPattern ? this.weeklyRepetitionPattern.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogRecurrencePatternResponse extends IAuditResponseObject {
    repeat: boolean;
    repeatEndType: string;
    repeatEndValue: string;
    repeatType: string;
    repeatInterval: number;
    weeklyRepetitionPattern: WeeklyRepetitionPatternResponse;
}

export class WeeklyRepetitionPatternResponse extends AuditResponseObject implements IWeeklyRepetitionPatternResponse {
    monday!: boolean;
    tuesday!: boolean;
    wednesday!: boolean;
    thursday!: boolean;
    friday!: boolean;
    saturday!: boolean;
    sunday!: boolean;

    constructor(data?: IWeeklyRepetitionPatternResponse) {
        super(data);
        this._discriminator = "WeeklyRepetitionPatternResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.monday = _data["monday"];
            this.tuesday = _data["tuesday"];
            this.wednesday = _data["wednesday"];
            this.thursday = _data["thursday"];
            this.friday = _data["friday"];
            this.saturday = _data["saturday"];
            this.sunday = _data["sunday"];
        }
    }

    static fromJS(data: any): WeeklyRepetitionPatternResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyRepetitionPatternResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monday"] = this.monday;
        data["tuesday"] = this.tuesday;
        data["wednesday"] = this.wednesday;
        data["thursday"] = this.thursday;
        data["friday"] = this.friday;
        data["saturday"] = this.saturday;
        data["sunday"] = this.sunday;
        super.toJSON(data);
        return data; 
    }
}

export interface IWeeklyRepetitionPatternResponse extends IAuditResponseObject {
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
}

export class AuditLogTaskTypeResponse extends AuditResponseObject implements IAuditLogTaskTypeResponse {
    contactRelated!: boolean;
    medicationRelated!: boolean;
    twoPersonTask!: boolean;
    referred!: boolean;

    constructor(data?: IAuditLogTaskTypeResponse) {
        super(data);
        this._discriminator = "AuditLogTaskTypeResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contactRelated = _data["contactRelated"];
            this.medicationRelated = _data["medicationRelated"];
            this.twoPersonTask = _data["twoPersonTask"];
            this.referred = _data["referred"];
        }
    }

    static fromJS(data: any): AuditLogTaskTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogTaskTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactRelated"] = this.contactRelated;
        data["medicationRelated"] = this.medicationRelated;
        data["twoPersonTask"] = this.twoPersonTask;
        data["referred"] = this.referred;
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogTaskTypeResponse extends IAuditResponseObject {
    contactRelated: boolean;
    medicationRelated: boolean;
    twoPersonTask: boolean;
    referred: boolean;
}

export class AuditLogTaskAssignmentResponse extends AuditResponseObject implements IAuditLogTaskAssignmentResponse {
    type?: AuditLogTaskTypeResponse | undefined;
    description?: AuditLogDescriptionResponse | undefined;
    executionInterval?: AuditLogExecutionIntervalResponse | undefined;
    recurrencePattern?: AuditLogRecurrencePatternResponse | undefined;
    professions?: AuditLogProfessionResponse | undefined;

    constructor(data?: IAuditLogTaskAssignmentResponse) {
        super(data);
        this._discriminator = "AuditLogTaskAssignmentResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] ? AuditLogTaskTypeResponse.fromJS(_data["type"]) : <any>undefined;
            this.description = _data["description"] ? AuditLogDescriptionResponse.fromJS(_data["description"]) : <any>undefined;
            this.executionInterval = _data["executionInterval"] ? AuditLogExecutionIntervalResponse.fromJS(_data["executionInterval"]) : <any>undefined;
            this.recurrencePattern = _data["recurrencePattern"] ? AuditLogRecurrencePatternResponse.fromJS(_data["recurrencePattern"]) : <any>undefined;
            this.professions = _data["professions"] ? AuditLogProfessionResponse.fromJS(_data["professions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditLogTaskAssignmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogTaskAssignmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["executionInterval"] = this.executionInterval ? this.executionInterval.toJSON() : <any>undefined;
        data["recurrencePattern"] = this.recurrencePattern ? this.recurrencePattern.toJSON() : <any>undefined;
        data["professions"] = this.professions ? this.professions.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogTaskAssignmentResponse extends IAuditResponseObject {
    type?: AuditLogTaskTypeResponse | undefined;
    description?: AuditLogDescriptionResponse | undefined;
    executionInterval?: AuditLogExecutionIntervalResponse | undefined;
    recurrencePattern?: AuditLogRecurrencePatternResponse | undefined;
    professions?: AuditLogProfessionResponse | undefined;
}

export class AuditLogAdditionalRepetitionIntervalsResponse extends AuditResponseObject implements IAuditLogAdditionalRepetitionIntervalsResponse {
    additionalRepetitionIntervals!: TaskEntryAdditionalRepetitionIntervalResponse[];

    constructor(data?: IAuditLogAdditionalRepetitionIntervalsResponse) {
        super(data);
        if (!data) {
            this.additionalRepetitionIntervals = [];
        }
        this._discriminator = "AuditLogAdditionalRepetitionIntervalsResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["additionalRepetitionIntervals"])) {
                this.additionalRepetitionIntervals = [] as any;
                for (let item of _data["additionalRepetitionIntervals"])
                    this.additionalRepetitionIntervals!.push(TaskEntryAdditionalRepetitionIntervalResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditLogAdditionalRepetitionIntervalsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogAdditionalRepetitionIntervalsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.additionalRepetitionIntervals)) {
            data["additionalRepetitionIntervals"] = [];
            for (let item of this.additionalRepetitionIntervals)
                data["additionalRepetitionIntervals"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAuditLogAdditionalRepetitionIntervalsResponse extends IAuditResponseObject {
    additionalRepetitionIntervals: TaskEntryAdditionalRepetitionIntervalResponse[];
}

export class TaskEntryAdditionalRepetitionIntervalResponse implements ITaskEntryAdditionalRepetitionIntervalResponse {
    id!: string;
    start!: string;
    end!: string;

    constructor(data?: ITaskEntryAdditionalRepetitionIntervalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.start = _data["start"];
            this.end = _data["end"];
        }
    }

    static fromJS(data: any): TaskEntryAdditionalRepetitionIntervalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskEntryAdditionalRepetitionIntervalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["start"] = this.start;
        data["end"] = this.end;
        return data; 
    }
}

export interface ITaskEntryAdditionalRepetitionIntervalResponse {
    id: string;
    start: string;
    end: string;
}

export class CreatedAssignmentInstructionsResponse implements ICreatedAssignmentInstructionsResponse {
    instructionIds!: string[];

    constructor(data?: ICreatedAssignmentInstructionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.instructionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["instructionIds"])) {
                this.instructionIds = [] as any;
                for (let item of _data["instructionIds"])
                    this.instructionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreatedAssignmentInstructionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedAssignmentInstructionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instructionIds)) {
            data["instructionIds"] = [];
            for (let item of this.instructionIds)
                data["instructionIds"].push(item);
        }
        return data; 
    }
}

export interface ICreatedAssignmentInstructionsResponse {
    instructionIds: string[];
}

export class AddAssignmentInstructionsRequest implements IAddAssignmentInstructionsRequest {
    instructions!: InstructionRequest[];
    actionId!: string;
    isMoved!: boolean;

    constructor(data?: IAddAssignmentInstructionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.instructions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(InstructionRequest.fromJS(item));
            }
            this.actionId = _data["actionId"];
            this.isMoved = _data["isMoved"];
        }
    }

    static fromJS(data: any): AddAssignmentInstructionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddAssignmentInstructionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item.toJSON());
        }
        data["actionId"] = this.actionId;
        data["isMoved"] = this.isMoved;
        return data; 
    }
}

export interface IAddAssignmentInstructionsRequest {
    instructions: InstructionRequest[];
    actionId: string;
    isMoved: boolean;
}

export class InstructionRequest implements IInstructionRequest {
    id!: string;
    order!: number;

    constructor(data?: IInstructionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): InstructionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        return data; 
    }
}

export interface IInstructionRequest {
    id: string;
    order: number;
}

export class AddAssignmentFormsRequest implements IAddAssignmentFormsRequest {
    forms!: FormRequest[];
    actionId!: string;
    isMoved!: boolean;

    constructor(data?: IAddAssignmentFormsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.forms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(FormRequest.fromJS(item));
            }
            this.actionId = _data["actionId"];
            this.isMoved = _data["isMoved"];
        }
    }

    static fromJS(data: any): AddAssignmentFormsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddAssignmentFormsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        data["actionId"] = this.actionId;
        data["isMoved"] = this.isMoved;
        return data; 
    }
}

export interface IAddAssignmentFormsRequest {
    forms: FormRequest[];
    actionId: string;
    isMoved: boolean;
}

export class FormRequest implements IFormRequest {
    formId!: string;
    required!: boolean;
    order!: number;
    paused!: boolean;

    constructor(data?: IFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.required = _data["required"];
            this.order = _data["order"];
            this.paused = _data["paused"];
        }
    }

    static fromJS(data: any): FormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["required"] = this.required;
        data["order"] = this.order;
        data["paused"] = this.paused;
        return data; 
    }
}

export interface IFormRequest {
    formId: string;
    required: boolean;
    order: number;
    paused: boolean;
}

export class UpdateAssignmentPrescriptionRequest implements IUpdateAssignmentPrescriptionRequest {
    prescriptionId?: string | undefined;
    actionId!: string;
    isMoved!: boolean;

    constructor(data?: IUpdateAssignmentPrescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"];
            this.actionId = _data["actionId"];
            this.isMoved = _data["isMoved"];
        }
    }

    static fromJS(data: any): UpdateAssignmentPrescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssignmentPrescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId;
        data["actionId"] = this.actionId;
        data["isMoved"] = this.isMoved;
        return data; 
    }
}

export interface IUpdateAssignmentPrescriptionRequest {
    prescriptionId?: string | undefined;
    actionId: string;
    isMoved: boolean;
}

export class TaskInstanceAssignmentsResponse implements ITaskInstanceAssignmentsResponse {
    instructions!: AssignmentInstructionResponse[];
    forms!: TaskInstanceAssignmentFormResponse[];
    prescription?: TaskInstanceAssignmentPrescriptionResponse | undefined;

    constructor(data?: ITaskInstanceAssignmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.instructions = [];
            this.forms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(AssignmentInstructionResponse.fromJS(item));
            }
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(TaskInstanceAssignmentFormResponse.fromJS(item));
            }
            this.prescription = _data["prescription"] ? TaskInstanceAssignmentPrescriptionResponse.fromJS(_data["prescription"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskInstanceAssignmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInstanceAssignmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item.toJSON());
        }
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        data["prescription"] = this.prescription ? this.prescription.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITaskInstanceAssignmentsResponse {
    instructions: AssignmentInstructionResponse[];
    forms: TaskInstanceAssignmentFormResponse[];
    prescription?: TaskInstanceAssignmentPrescriptionResponse | undefined;
}

export class TaskInstanceAssignmentFormResponse implements ITaskInstanceAssignmentFormResponse {
    order!: number;
    formId!: string;
    required!: boolean;
    registrationId?: string | undefined;

    constructor(data?: ITaskInstanceAssignmentFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.formId = _data["formId"];
            this.required = _data["required"];
            this.registrationId = _data["registrationId"];
        }
    }

    static fromJS(data: any): TaskInstanceAssignmentFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInstanceAssignmentFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["formId"] = this.formId;
        data["required"] = this.required;
        data["registrationId"] = this.registrationId;
        return data; 
    }
}

export interface ITaskInstanceAssignmentFormResponse {
    order: number;
    formId: string;
    required: boolean;
    registrationId?: string | undefined;
}

export class TaskInstanceAssignmentPrescriptionResponse implements ITaskInstanceAssignmentPrescriptionResponse {
    prescriptionId!: string;
    registrationId?: string | undefined;

    constructor(data?: ITaskInstanceAssignmentPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"];
            this.registrationId = _data["registrationId"];
        }
    }

    static fromJS(data: any): TaskInstanceAssignmentPrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInstanceAssignmentPrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId;
        data["registrationId"] = this.registrationId;
        return data; 
    }
}

export interface ITaskInstanceAssignmentPrescriptionResponse {
    prescriptionId: string;
    registrationId?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}